<template>
    <div class="wrapper-sims-list wrapper-disable">
        <div class="wrap-sims">
            <div class="card overflow-visible">
                <div class="card-header">
                    <div>SIM Management</div>
                </div>
                <div class="card-body">
                    <div class="siot-table-wrapper">
                        <div class="siot-table-header">
                            <div class="siot-table-header-left">
                                <div class="siot-table-search">
                                    <div class="siot-table-search-field">
                                        <input type="text" id="simManagementSearch" v-model="filter" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown" placeholder="Search">
                                    </div>
                                </div>
                                <div class="siot-table-filter">
                                    <button class="btn btn-primary filter-btn" id="simManagementFilter" @click="clickFilters()"><i class="fa fa-filter"></i>Filter</button>
                                    <button class="btn btn-primary mobile-sort-btn" id="simManagmentSort" @click="shwoHideSort()"><i class="fa fa-sort" aria-hidden="true"></i>Sort</button>
                                </div>
                            </div>

                            <div class="siot-table-header-right">
                                <div class="siot-table-export">
                                    <select v-model="exportOption" id="export-setting" class="form-control export-dropdown custom-select">
                                        <option value="2">Export: Current Page</option>
                                        <option value="3">Export: All pages</option>
                                    </select>
                                    <button id="simManagementExport" class="btn btn-primary" v-on:click="showfileFormatPopup = true">Export</button>
                                </div>
                                <div class="siot-table-size">
                                    <label for="size-page">Display:</label>
                                    <select v-on:change="sizePage" v-model="sortSettings.size" id="size-page" class="custom-select form-control">
                                        <option value="40">40</option>
                                        <option value="60">60</option>
                                        <option value="80">80</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="siot-table-content">
                            <div v-if="mobileVisible == true" class="list-mobile">
                                <div v-for="(item, index) in simsList" :data-iccid="item.iccid" v-bind:key="index" class="item-mobile" v-on:click="showModal(item.iccid)">
                                    <div class="item-header-mobile">
                                        <div v-if="item.carrierId == 1" class="icon-mobile">
                                            <img src="../../assets/img/carrier-simon.svg" alt="Simon Carrier Logo">
                                        </div>
                                        <div v-else-if="item.carrierId == 2" class="icon-mobile">
                                            <img src="../../assets/img/carrier-tmobile.svg" alt="Tmobile Carrier Logo">
                                        </div>
                                        <div v-else-if="item.carrierId == 3" class="icon-mobile">
                                            <img src="../../assets/img/carrier-vodafone.svg" alt="Vodafone Carrier Logo">
                                        </div>
                                        <div class="info-wrapper-mobile">
                                            <div class="info-mobile">
                                                <strong>{{item.iccid}}</strong>
                                                <span class="status">Status <em>{{item.status}}</em></span>
                                            </div>
                                            <div class="tags">
                                                <span class="tag-iterator" v-if="item.tags && item.tags.length == 1">{{item.tags.length}} tag</span>
                                                <span class="tag-iterator" v-else-if="item.tags && item.tags.length > 1">{{item.tags.length}} tags</span>
                                                <span class="tag-iterator" v-else>0 tags</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="data-table-mobile">
                                        <div class="row-mobile">
                                            <div class="icon-mobile">
                                                <img src="../../assets/img/mobile-icons/mobile-icon14.svg" alt="">
                                            </div>
                                            <div class="info">
                                                <span class="label">MSISDN</span>
                                                <span class="value">{{item.msisdn}}</span>
                                            </div>
                                        </div>
                                        <div class="row-mobile">
                                            <div class="icon-mobile">
                                                <img src="../../assets/img/mobile-icons/mobile-icon4.svg" alt="">
                                            </div>
                                            <div class="info">
                                                <span class="label">Plan</span>
                                                <span class="value">{{item.ratePlanName}}</span>
                                            </div>
                                        </div>
                                        <div class="row-mobile">
                                            <div class="icon-mobile">
                                                <img src="../../assets/img/mobile-icons/mobile-icon11.svg" alt="">
                                            </div>
                                            <div class="info">
                                                <span class="label">{{custom1}}</span>
                                                <span class="value" v-if="item.customFields && item.customField1">{{item.customField1}}</span><span class="value" v-else>-</span>
                                            </div>
                                        </div>
                                        <div class="row-mobile">
                                            <div class="icon-mobile">
                                                <img src="../../assets/img/mobile-icons/mobile-icon11.svg" alt="">
                                            </div>
                                            <div class="info">
                                                <span class="label">{{custom2}}</span>
                                                <span class="value" v-if="item.customFields && item.customField2">{{item.customField2}}</span><span class="value" v-else>-</span>
                                            </div>
                                        </div>
                                        <div class="row-mobile">
                                            <div class="icon-mobile">
                                                <img src="../../assets/img/mobile-icons/mobile-icon9.svg" alt="">
                                            </div>
                                            <div class="info">
                                                <span class="label">Last Active</span>
                                                <span class="value">{{item.lastActiveOn}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-else class="siot-table siot-table-managment table-responsive-sm">
                                <table  v-if='simsList' class="table b-table table-striped table-hover b-table-selectable b-table-select-multi table-managment">
                                    <thead role="rowgroup">
                                        <tr role="row" class="siot-table-head">
                                            <th v-on:click="changesSort" role="columnheader" aria-colindex="1" aria-label="Sim" aria-sort="none">SIM</th>
                                            <th v-on:click="changesSort" role="columnheader" aria-colindex="2" aria-label="Phone" aria-sort="none">MSISDN</th>
                                            <th v-on:click="changesSort" role="columnheader" aria-colindex="3" aria-label="Status" aria-sort="none">Status</th>
                                            <th v-if="custom1" v-on:click="changesSort" role="columnheader" aria-colindex="4" :aria-label="custom1">{{custom1}}</th>
                                            <th v-if="custom2" v-on:click="changesSort" role="columnheader" aria-colindex="5" :aria-label="custom2">{{custom2}}</th>
                                            <th v-on:click="changesSort" role="columnheader" aria-colindex="6" aria-label="Carrier" aria-sort="none">Carrier</th>
                                            <th role="columnheader" aria-label="Tags">Tags</th>
                                            <th v-on:click="changesSort" role="columnheader" aria-colindex="7" aria-label="Last Active" aria-sort="none">Last Active</th>
                                            <th v-on:click="changesSort" role="columnheader" aria-colindex="9" aria-label="Plan" aria-sort="none">Plan</th>
                                        </tr>
                                    </thead>
                                    <tbody class="siot-table-body">
                                        <tr v-for="(item, index) in simsList" :data-iccid="item.iccid" v-bind:key="index">
                                            <td v-on:click="showModal(item.iccid)" :title="item.iccid">{{item.iccid}}</td>
                                            <td v-on:click="showModal(item.iccid)" :title="item.msisdn">{{item.msisdn}}</td>
                                            <td v-on:click="showModal(item.iccid)" :title="item.status">{{item.status}}</td>
                                            <td v-if="custom1" v-on:click="showModal(item.iccid)" :title="item.customField1"><span v-if="item.customFields && item.customField1">{{item.customField1}}</span><span v-else>-</span></td>
                                            <td v-if="custom2" v-on:click="showModal(item.iccid)" :title="item.customField2"><span v-if="item.customFields && item.customField2">{{item.customField2}}</span><span v-else>-</span></td>
                                            <td v-on:click="showModal(item.iccid)">
                                                <span class="carrier-cell" v-if="item.carrierId && item.carrierId == 1">SimonIoT
                                                    <span :class="['plan-category-type', item.planCategoryType.categoryName]">{{item.planCategoryType.displayValue}}</span>
                                                </span>
                                                <span v-else-if="item.carrierId && item.carrierId == 2">T-Mobile</span>
                                                <span v-else-if="item.carrierId && item.carrierId == 3">Vodafone</span>
                                                <span v-else-if="item.carrierId && item.carrierId == 4">Kore</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td class="tag-column" v-on:click="showModal(item.iccid)">
                                                <span @mouseenter="showTags" @mouseleave="hideTags" class="tag-iterator" v-if="item.tags && item.tags.length == 1">{{item.tags.length}} tag</span>
                                                <span @mouseenter="showTags" @mouseleave="hideTags" class="tag-iterator" v-else-if="item.tags && item.tags.length > 1">{{item.tags.length}} tags</span>
                                                <span class="tag-iterator" v-else>0 tags</span>
                                                <p class="tagslist" v-if="item.tags">
                                                    <span class="tag" v-for="(tag, key) in item.tags" v-bind:key="key">{{tag}}<em>,</em></span>
                                                </p>
                                            </td>
                                            <td v-on:click="showModal(item.iccid)" :title="item.lastActiveOn">
                                                <span v-if="item.lastActiveOn">{{item.lastActiveOn}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td v-on:click="showModal(item.iccid)" :title="item.ratePlanName">{{item.ratePlanName}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="loader-sim-list" v-if="loadingSimList && noSims == false">
                                <div class="sk-wave">
                                    <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                                </div>
                            </div>

                            <div class="no-sims" v-if="loadingSimList == false && noSims == true">
                                <h2 class="text">No Plans are available for the selected SIM card Statuses</h2>
                            </div>
                        </div>

                        <div class="siot-table-footer">
                            <div class="siot-table-footer-center">
                                <nav v-if="paginationCount" aria-label="Page navigation example">
                                    <paginate :page-count="paginationCount" v-model="sortSettings.page" :click-handler="paginationControll" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></paginate>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="filtersShown" class="filters">
            <div class="filters-box">
                <div class="inner-filters">
                    <img src="../../assets/img/Close.svg" @click="cancelFilters()" class="close-filters-icon light-mode" alt="">
                    <img src="../../assets/img/Close-darkmode.svg" @click="cancelFilters()" class="close-filters-icon dark-mode" alt="">
                    <div class="filters-content">
                        <div class="filters-search">
                            <div class="FTSsearch">
                                <i class="fa fa-search"></i>
                                <input type="text" v-model="filtersSearch" placeholder="Search"/>
                                <img src="../../assets/img/Clear-field.svg" class="clear-filters-icon light-mode" @click="clearFilters()" alt="">
                                <img src="../../assets/img/Clear-field-darkmode.svg" class="clear-filters-icon dark-mode" @click="clearFilters()" alt="">
                            </div>
                        </div>
                        <div class="filter-columns">
                            <div class="column statuses">
                                <div v-if="simonCarrierAvailable || tmobileCarrierAvailable" class="statuses-box double">
                                    <div v-if="simonCarrierAvailable" :class="['company-statuses-box', 'part-' + countCarriers]" id="simonStatuses">
                                        <div class="logo-switch-row">
                                            <img src="../../assets/img/simon-carrier.svg" class="light-mode">
                                            <img src="../../assets/img/simon-carrier-dark.svg" class="dark-mode">
                                        </div>
                                        <div class="statuses-list">
                                            <FTScheckbox @change.native="selectAll('simon')" v-model="statuses.simon.all" :label="'All'"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Active') ? '' : 'hidden'" @change.native="switchStatus(1)" v-model="statuses.simon.active" :label="'Active'"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Active - Ready') ? '' : 'hidden'" @change.native="switchStatus(1)" v-model="statuses.simon.activeReady" :label="'Active - Ready'"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Suspended') ? '' : 'hidden'" @change.native="switchStatus(1)" v-model="statuses.simon.suspended" :label="'Suspended'"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('SIM Bank') ? '' : 'hidden'" @change.native="switchStatus(1)" v-model="statuses.simon.simBank" :label="'SIM Bank'"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Inactive') ? '' : 'hidden'" @change.native="switchStatus(1)" v-model="statuses.simon.inactive" :label="'Inactive'"></FTScheckbox>
                                        </div>
                                    </div>
                                    <div v-if="tmobileCarrierAvailable" :class="['company-statuses-box', 'part-' + countCarriers]" id="tmobileStatuses">
                                        <div class="logo-switch-row">
                                            <img src="../../assets/img/t-mobile-carrier.svg">
                                        </div>
                                        <div class="statuses-list">
                                            <FTScheckbox @change.native="selectAll('tmobile')" v-model="statuses.tmobile.all" :label="'All '"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Active') ? '' : 'hidden'" @change.native="switchStatus(2)" v-model="statuses.tmobile.active" :label="'Active '"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Suspended') ? '' : 'hidden'" @change.native="switchStatus(2)" v-model="statuses.tmobile.suspended" :label="'Suspended '"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Inactive') ? '' : 'hidden'" @change.native="switchStatus(2)" v-model="statuses.tmobile.inactive" :label="'Inactive '"></FTScheckbox>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="vodafoneCarrierAvailable" class="statuses-box">
                                    <div :class="['company-statuses-box', 'part-' + countCarriers]" id="vodafoneStatuses">
                                        <div class="logo-switch-row">
                                            <img src="../../assets/img/vodafone-logo.svg">
                                        </div>
                                        <div class="statuses-list">
                                            <FTScheckbox @change.native="selectAll('vodafone')" v-model="statuses.vodafone.all" :label="'All  '"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Active - Live') ? '' : 'hidden'" @change.native="switchStatus(3)" v-model="statuses.vodafone.activeLive" :label="'Active - Live'"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Active - Sleep') ? '' : 'hidden'" @change.native="switchStatus(3)" v-model="statuses.vodafone.activeSleep" :label="'Active - Sleep'"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Active - Ready') ? '' : 'hidden'" @change.native="switchStatus(3)" v-model="statuses.vodafone.activeReady" :label="'Active - Ready '"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Active - Suspended') ? '' : 'hidden'" @change.native="switchStatus(3)" v-model="statuses.vodafone.activeSuspended" :label="'Active - Suspended'"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Active - Test') ? '' : 'hidden'" @change.native="switchStatus(3)" v-model="statuses.vodafone.activeTest" :label="'Active - Test'"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Active - Standby') ? '' : 'hidden'" @change.native="switchStatus(3)" v-model="statuses.vodafone.activeStandby" :label="'Active - Standby'"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Inactive - Stopped') ? '' : 'hidden'" @change.native="switchStatus(3)" v-model="statuses.vodafone.inactiveStopped" :label="'Inactive - Stopped'"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Inactive') ? '' : 'hidden'" @change.native="switchStatus(3)" v-model="statuses.vodafone.inactive" :label="'Inactive  '"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Terminated') ? '' : 'hidden'" @change.native="switchStatus(3)" v-model="statuses.vodafone.terminated" :label="'Terminated'"></FTScheckbox>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="koreCarrierAvailable" class="statuses-box">
                                    <div :class="['company-statuses-box', 'part-' + countCarriers]" id="koreStatuses">
                                        <div class="logo-switch-row">
                                            <img src="../../assets/img/kore-logo.svg">
                                        </div>
                                        <div class="statuses-list">
                                            <FTScheckbox @change.native="selectAll('kore')" v-model="statuses.kore.all" :label="'All   '"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Active') ? '' : 'hidden'" @change.native="switchStatus(4)" v-model="statuses.kore.active" :label="'Active  '"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Active - Test') ? '' : 'hidden'" @change.native="switchStatus(4)" v-model="statuses.kore.activeTest" :label="'Active - Test '"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Active - Ready') ? '' : 'hidden'" @change.native="switchStatus(4)" v-model="statuses.kore.activeReady" :label="'Active - Ready  '"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Suspended') ? '' : 'hidden'" @change.native="switchStatus(4)" v-model="statuses.kore.suspended" :label="'Suspended  '"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Suspended with Charge') ? '' : 'hidden'" @change.native="switchStatus(4)" v-model="statuses.kore.suspendedWithCharge" :label="'Suspended with Charge'"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Terminated') ? '' : 'hidden'" @change.native="switchStatus(4)" v-model="statuses.kore.terminated" :label="'Terminated '"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Pending Termination') ? '' : 'hidden'" @change.native="switchStatus(4)" v-model="statuses.kore.pendingScrap" :label="'Pending Termination'"></FTScheckbox>
                                            <FTScheckbox :class="filterStatuses('Deactivated') ? '' : 'hidden'" @change.native="switchStatus(4)" v-model="statuses.kore.deactivated" :label="'Deactivated'"></FTScheckbox>
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <div class="column tags">
                                <div class="tags-box">
                                    <h4 class="tags-title">Tags</h4>
                                    <p v-if="selectedTags.length" class="selected-tags-count">{{selectedTagsCounter}}</p>
                                    <div v-if="selectedTags.length" class="selected-tags-list">
                                        <div v-for="tag in selectedTags" v-bind:key="tag.id" :class="['selected-tag', tag.selected ? '' : 'hidden']">{{tag.label}}<img @click="deselectTag(tag)" src="../../assets/img/deselct-tag-icon.svg" class="close-cross"/></div>
                                    </div>

                                    <div class="tag-list-sort">
                                        <span>Sort by: </span>
                                        <a v-if="(searchTag.sort == 1 && !searchTag.desc) || searchTag.sort == 2" :class="[searchTag.sort == 1 ? 'sorting' : '']" @click="setAlpha">A-Z<i :class="['fa', searchTag.sort == 1 ? 'fa-sort-asc' : 'fa-sort']"></i></a>
                                        <a v-if="searchTag.sort == 1 && searchTag.desc" :class="[searchTag.sort == 1 ? 'sorting' : '']" @click="setAlpha">Z-A<i :class="['fa', 'fa-sort-desc']"></i></a>
                                        <a v-if="(searchTag.sort == 2 && !searchTag.desc) || searchTag.sort == 1" :class="[searchTag.sort == 2 ? 'sorting' : '']" @click="setMostUsed">Unused<i :class="['fa', searchTag.sort == 2 ? 'fa-sort-desc' : 'fa-sort']"></i></a>
                                        <a v-if="searchTag.sort == 2 && searchTag.desc" :class="[searchTag.sort == 2 ? 'sorting' : '']" @click="setMostUsed">Used<i class="fa fa-sort-asc"></i></a>
                                    </div>
                                    <h4 class="tags-list-header">Tags List</h4>
                                    <div class="tags-list">
                                        <div v-for="tag in tagsList" :class="['tag', tag.selected ? 'selected' : '', filtersSearch != '' && searchTags(tag) ? 'hidden' : '']" @click="selectTag(tag)">{{tag.label}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="column plans">
                                <div class="plans-box">
                                    <h4 class="plans-title">Plans</h4>
                                    <p v-if="selectedPlans.length > 0" class="selected-plans-counter">{{selectedPlansCounter}}</p>
                                    <div v-if="selectedPlans.length > 0" class="selected-plans-box">
                                        <div v-for="plan in selectedPlans" :class="['selected-plan', plan.carrierId == 1 ? 'simon-plan' : plan.carrierId == 2 ? 'tmobile-plan' : plan.carrierId == 3 ? 'vodafone-plan' : plan.carrierId == 4 ? 'kore-plan' : '']">
                                            <img v-if="plan.carrierId == 1" src="../../assets/img/simon-plan-logo.svg" class="company-plan-logo">
                                            <img v-else-if="plan.carrierId == 2"  src="../../assets/img/tmobile-plan-logo.svg" class="company-plan-logo">
                                            <img v-else-if="plan.carrierId == 3"  src="../../assets/img/vodafone-plan-logo.svg" class="company-plan-logo">
                                            <span>{{plan.name}}</span>
                                            <img src="../../assets/img/deselct-tag-icon.svg" @click="deselectPlan(plan)" alt="" class="close-cross">
                                        </div>
                                    </div>

                                    <div class="plans-filters-box">
                                        <a :class="[plansFilterSelected == 0 ? 'active-filter' : '']" @click="setPlansFilter(0)">ALL</a>
                                        <a v-if="simonFilter || vodafoneFilter" :class="[plansFilterSelected == 1 ? 'active-filter' : '']" @click="setPlansFilter(1)">MB</a>
                                        <a v-if="simonFilter || vodafoneFilter" :class="[plansFilterSelected == 2 ? 'active-filter' : '']" @click="setPlansFilter(2)">GB</a>
                                        <a v-if="simonFilter" :class="[plansFilterSelected == 3 ? 'active-filter' : '']" @click="setPlansFilter(3)">Simon IoT</a>
                                        <a v-if="tmobileFilter" :class="[plansFilterSelected == 4 ? 'active-filter' : '']" @click="setPlansFilter(4)">T-Mobile</a>
                                        <a v-if="vodafoneFilter" :class="[plansFilterSelected == 5 ? 'active-filter' : '']" @click="setPlansFilter(5)">Vodafone</a>
                                        <a v-if="koreFilter" :class="[plansFilterSelected == 6 ? 'active-filter' : '']" @click="setPlansFilter(6)">Kore</a>
                                    </div>
                                    <div class="plans-list">
                                        <div :class="['plans-alpha-box', plansParsed.A.length == 0 || (searchThroughPlans(plansParsed.A)) ? 'hidden' : '' ]">
                                            <h6>A</h6>
                                            <FTScheckbox v-for="plan in plansParsed.A" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.B.length == 0 || (searchThroughPlans(plansParsed.B)) ? 'hidden' : '' ]">
                                            <h6>B</h6>
                                            <FTScheckbox v-for="plan in plansParsed.B" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.C.length == 0 || (searchThroughPlans(plansParsed.C)) ? 'hidden' : '' ]">
                                            <h6>C</h6>
                                            <FTScheckbox v-for="plan in plansParsed.C" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.D.length == 0 || (searchThroughPlans(plansParsed.D)) ? 'hidden' : '' ]">
                                            <h6>D</h6>
                                            <FTScheckbox v-for="plan in plansParsed.D" v-bind:key="plan.id" :checked="plan.selected" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.E.length == 0 || (searchThroughPlans(plansParsed.E)) ? 'hidden' : '' ]">
                                            <h6>E</h6>
                                            <FTScheckbox v-for="plan in plansParsed.E" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.F.length == 0 || (searchThroughPlans(plansParsed.F)) ? 'hidden' : '' ]">
                                            <h6>F</h6>
                                            <FTScheckbox v-for="plan in plansParsed.F" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.G.length == 0 || (searchThroughPlans(plansParsed.G)) ? 'hidden' : '' ]">
                                            <h6>G</h6>
                                            <FTScheckbox v-for="plan in plansParsed.G" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.H.length == 0 || (searchThroughPlans(plansParsed.H)) ? 'hidden' : '' ]">
                                            <h6>H</h6>
                                            <FTScheckbox v-for="plan in plansParsed.H" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.I.length == 0 || (searchThroughPlans(plansParsed.I)) ? 'hidden' : '' ]">
                                            <h6>I</h6>
                                            <FTScheckbox v-for="plan in plansParsed.I" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.J.length == 0 || (searchThroughPlans(plansParsed.J)) ? 'hidden' : '' ]">
                                            <h6>J</h6>
                                            <FTScheckbox v-for="plan in plansParsed.J" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.K.length == 0 || (searchThroughPlans(plansParsed.K)) ? 'hidden' : '' ]">
                                            <h6>K</h6>
                                            <FTScheckbox v-for="plan in plansParsed.K" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.L.length == 0 || (searchThroughPlans(plansParsed.L)) ? 'hidden' : '' ]">
                                            <h6>L</h6>
                                            <FTScheckbox v-for="plan in plansParsed.L" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.M.length == 0 || (searchThroughPlans(plansParsed.M)) ? 'hidden' : '' ]">
                                            <h6>M</h6>
                                            <FTScheckbox v-for="plan in plansParsed.M" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.N.length == 0 || (searchThroughPlans(plansParsed.N)) ? 'hidden' : '' ]">
                                            <h6>N</h6>
                                            <FTScheckbox v-for="plan in plansParsed.N" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.O.length == 0 || (searchThroughPlans(plansParsed.O)) ? 'hidden' : '' ]">
                                            <h6>O</h6>
                                            <FTScheckbox v-for="plan in plansParsed.O" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.P.length == 0 || (searchThroughPlans(plansParsed.P)) ? 'hidden' : '' ]">
                                            <h6>P</h6>
                                            <FTScheckbox v-for="plan in plansParsed.P" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.Q.length == 0 || (searchThroughPlans(plansParsed.Q)) ? 'hidden' : '' ]">
                                            <h6>Q</h6>
                                            <FTScheckbox v-for="plan in plansParsed.Q" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.R.length == 0 || (searchThroughPlans(plansParsed.R)) ? 'hidden' : '' ]">
                                            <h6>R</h6>
                                            <FTScheckbox v-for="plan in plansParsed.R" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.S.length == 0 || (searchThroughPlans(plansParsed.S)) ? 'hidden' : '' ]">
                                            <h6>S</h6>
                                            <FTScheckbox v-for="plan in plansParsed.S" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.T.length == 0 || (searchThroughPlans(plansParsed.T)) ? 'hidden' : '' ]">
                                            <h6>T</h6>
                                            <FTScheckbox v-for="plan in plansParsed.T" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.U.length == 0 || (searchThroughPlans(plansParsed.U)) ? 'hidden' : '' ]">
                                            <h6>U</h6>
                                            <FTScheckbox v-for="plan in plansParsed.U" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.V.length == 0 || (searchThroughPlans(plansParsed.V)) ? 'hidden' : '' ]">
                                            <h6>V</h6>
                                            <FTScheckbox v-for="plan in plansParsed.V" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.W.length == 0 || (searchThroughPlans(plansParsed.W)) ? 'hidden' : '' ]">
                                            <h6>W</h6>
                                            <FTScheckbox v-for="plan in plansParsed.W" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.X.length == 0 || (searchThroughPlans(plansParsed.X)) ? 'hidden' : '' ]">
                                            <h6>X</h6>
                                            <FTScheckbox v-for="plan in plansParsed.X" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.Y.length == 0 || (searchThroughPlans(plansParsed.Y)) ? 'hidden' : '' ]">
                                            <h6>Y</h6>
                                            <FTScheckbox v-for="plan in plansParsed.Y" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.Z.length == 0 || (searchThroughPlans(plansParsed.Z)) ? 'hidden' : '' ]">
                                            <h6>Z</h6>
                                            <FTScheckbox v-for="plan in plansParsed.Z" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                        <div :class="['plans-alpha-box', plansParsed.misc.length == 0 || (searchThroughPlans(plansParsed.misc)) ? 'hidden' : '' ]">
                                            <h6>Miscellaneous</h6>
                                            <FTScheckbox v-for="plan in plansParsed.misc" v-bind:key="plan.id" @change.native="selectPlan(plan)" v-model="plan.selected" :class="[searchPlans(plan) ? '' : 'hidden', filterPlans(plan) ? '' : 'hidden']" :label="plan.name"></FTScheckbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="filters-control-bar">
                        <div class="left-side">
                            <button class="btn btn-light" @click="setDefaultFilters()">Set default</button>
                        </div>
                        <div class="right-side">
                            <button class="btn btn-light" @click="cancelFilters()">Cancel</button>
                            <button class="btn btn-primary" @click="runFilters()">Apply</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="['wrapper-modal', (showfileFormatPopup) ? '' : 'wrapper-disable']">
            <div class="file-format-popup">
                <i class="close-icon fa fa-close" v-on:click="showfileFormatPopup = false"></i>
                <img src="../../assets/img/file-format.svg">
                <h3>Save export file as:</h3>
                <div>
                    <button class="btn btn-primary csv" v-on:click="exportCsv">CSV</button>
                    <button class="btn btn-primary xls" v-on:click="exportXlsx">XLSX</button>
                </div>
                <button class="btn btn-light" v-on:click="showfileFormatPopup = false">Cancel</button>
            </div>
        </div>
        <BulkModal ref="childBulkModal"></BulkModal>
        <FTSSort v-if="mobileSort.visible" :settingsSort="sortingSettings" :directionSort="sortSettings.desc" :columnSort="sortSettings.sort" v-on:hideSort="shwoHideSort" v-on:submitSort="submitSort"></FTSSort>
    </div>
</template>

<script>
import Vue from 'vue';
import Axios from "axios";
import globalStore from "../../variables";
import VueGoogleCharts from 'vue-google-charts';
import ftsGetDataTable from '@/views/table/ftsGetDataTable'
import Paginate from 'vuejs-paginate'
import { stat } from 'fs';
import BulkModal from './BulkModal'
import VueSession from "vue-session";
import { Switch as cSwitch } from "@coreui/vue";
import FTScheckbox from "../../ftsComponents/FTScheckbox";
import FTSsearch from "../../ftsComponents/FTSsearch";
import FTSSort from "../../ftsComponents/FTSSort";

Vue.use(VueSession);

Vue.use(VueGoogleCharts);

export default {
    name: "Managment",
    components: {
        FTScheckbox,
        ftsGetDataTable: ftsGetDataTable,
        Paginate: Paginate,
        BulkModal: BulkModal,
        cSwitch,
        FTSsearch,
        FTSSort,
    },
    data() {
        return {
            mobileVisible: false,
            noSims: false,
            loadingSimList: true,
            bulkActictionValue: '#',
            numberSim: 0,
            component: false,
            simId: 0,
            simsList: [],
            Modal: false,
            filter: '',
            select: {
                style: "os",
                selector: "td:first-child"
            },
            sortSettings: {
                page: 1,
                size: 40,
                sort: 0,
                desc: true
            },
            pagination: {
                length: 0,
                min: 1,
                max: 0
            },
            paginationItems: [],
            paginationCount: 0,
            searchString: '',
            fileWithSimList: '',
            exportOption: "2",
            visibilityBulkModal: 0,
            showfileFormatPopup: false,
            customFields: true,
            custom1: null,
            custom2: null,
            typingTimer: '',
            companyName: '',
            filtersShown: false,
            simonCarrierAvailable: false,
            tmobileCarrierAvailable: false,
            vodafoneCarrierAvailable: false,
            koreCarrierAvailable: false,
            countCarriers: 0,
            searchTag: {
                sort: 1,
                desc: false
            },
            tagsList: [],
            selectedTags: [],
            selectedTagsCounter: '',
            plansList: [],
            selectedPlans: [],
            selectedPlansCounter: '',
            filtersSearch: '',
            simonFilter: true,
            vodafoneFilter: true,
            koreFilter: true,
            tmobileFilter: true,
            plansParsed: {
                A: [],
                B: [],
                C: [],
                D: [],
                E: [],
                F: [],
                G: [],
                H: [],
                I: [],
                J: [],
                K: [],
                L: [],
                M: [],
                N: [],
                O: [],
                P: [],
                Q: [],
                R: [],
                S: [],
                T: [],
                U: [],
                V: [],
                W: [],
                X: [],
                Y: [],
                Z: [],
                misc: []
            },
            plansFilterSelected: 0,
            statuses: {
                simon: {
                    all: true,
                    active: true,
                    activeReady: true,
                    suspended: true,
                    simBank: true,
                    inactive: true
                },
                tmobile: {
                    all: true,
                    active: true,
                    suspended: true,
                    inactive: true
                },
                vodafone: {
                    all: true,
                    activeLive: true,
                    activeSleep: true,
                    activeReady: true,
                    activeSuspended: true,
                    activeTest: true,
                    activeStandby: true,
                    inactiveStopped: true,
                    terminated: true,
                    inactive: true
                },
                kore: {
                    all: true,
                    active: true,
                    activeTest: true,
                    activeReady: true,
                    suspended: true,
                    suspendedWithCharge: true,
                    terminated: true,
                    pendingScrap: true,
                    deactivated: true
                }
            },
            plans: {
                simon: [],
                tmobile: [],
                vodafone: []
            },
            filters: '',
            initialFilters: {},
            historicalSims: false,
            toggleSort: false,
            sortingSettings: [
                {
                    label: 'Status',
                    column: 3
                },
                {
                    label: 'Carrier',
                    column: 6
                },
                {
                    label: 'Last Active',
                    column: 7
                },
                {
                    label: 'Plans',
                    column: 9
                },
                {
                    label: 'SIM',
                    column: 1
                },
                {
                    label: 'MSISDN',
                    column: 2
                },
            ],
            mobileSort: {
                column: 0,
                direction: 0,
                visible: false
            }
        };
    },
    methods: {
        submitSort(value) {
            this.sortSettings.sort = value.column;
            this.sortSettings.desc = value.direction;
            this.getSimsList(true);
        },
        shwoHideSort() {
            this.mobileSort.visible = (this.mobileSort.visible == true) ? false : true;
        },
        searchKeyUp() {
            clearTimeout(this.typingTimer)
            this.typingTimer = setTimeout(() => {
                this.searchRow()
            }, 500)
        },
        searchKeyDown() {
            clearTimeout(this.typingTimer)
        },
        searchRow: function () {
            this.loadingSimList = true;
            if (this.filter.length > 0) {
                this.searchString = '&search=' + escape(this.filter);
            } else {
                this.searchString = '';
            }
            this.getSimsList(true)
        },
        paginationControll(ev) {
            this.loadingSimList = true;
            this.sortSettings.page = ev;
            this.getSimsList(false);
        },
        getPagination() {
            Axios.get(globalStore.data.restApiUrl + '/sim-page-count?size=' + this.sortSettings.size + this.filters + this.searchString)
                .then(response => {
                    if (response.status == 200) {
                        this.paginationCount = Number (response.data);
                    } else {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'Error Sorting SIM List - Contact Support',
                            duration: 5000,
                        });
                        return false;
                    }
                }).catch(error => {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Getting data error',
                    text: 'Error Sorting SIM List - Contact Support',
                    duration: 5000,
                });
                console.log(error)

                return false;
            })
        },
        getSimsList(notPagination) {
            if (notPagination){
                this.sortSettings.page = 1;
                this.getPagination();
            }

            Axios.get(globalStore.data.restApiUrl + '/sims?page=' + this.sortSettings.page + '&size=' + this.sortSettings.size + '&desc=' + this.sortSettings.desc + '&sort=' + this.sortSettings.sort + this.searchString + this.filters)
                .then(response => {
                    if (response.status == 200) {

                        if (response.data.response) {
                            this.noSims = false;
                            let simList = response.data.response;

                            simList.map(simRow => {
                                if (simRow.customFields) {
                                    simRow.customFields.map(customField => {
                                        if (customField.customFieldId == 1) {
                                            simRow.customField1 = customField.customFieldName
                                        }

                                        if (customField.customFieldId == 2) {
                                            simRow.customField2 = customField.customFieldName
                                        }
                                    })
                                }
                            })

                            this.simsList = simList;
                            setTimeout(() => {
                                this.loadingSimList = false;
                            }, 500)
                        } else {
                            this.simsList = [];
                            this.noSims = true;
                            setTimeout(() => {
                                this.loadingSimList = false;
                            }, 500)
                        }
                    } else {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'Error Retrieving SIM List - Contact Support',
                            duration: 5000,
                        });
                        setTimeout(() => {
                            this.loadingSimList = false;
                        }, 500)

                        return false;
                    }
                }).catch(error => {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Getting data error',
                    text: 'Error Retrieving SIM List - Contact Support',
                    duration: 5000,
                });
                console.log(error)
                setTimeout(() => {
                    this.loadingSimList = false;
                }, 500)

                return false;
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        showModal: function(simNumber) {
            this.$session.set('simManagementSortSettings', this.sortSettings)
            if (this.simonFilter) {
                this.$session.set('simonFilter', this.simonFilter)
            }
            if (this.tmobileFilter) {
                this.$session.set('tmobileFilter', this.tmobileFilter)
            }
            if (this.vodafoneFilter) {
                this.$session.set('vodafoneFilter', this.vodafoneFilter)
            }
            this.$session.set('statuses', this.statuses)
            if (this.selectedTags.length > 0) {
                this.$session.set('tags', this.tagsList)
                this.$session.set('selectedTags', this.selectedTags)
            }
            if (this.selectedPlans.length > 0) {
                this.$session.set('plansParsed', this.plansParsed)
                this.$session.set('selectedPlans', this.selectedPlans)
            }
            this.$session.set('filters', this.filters)
            this.$session.set('filter', this.filter)
            this.$session.set('paginationCount', this.paginationCount)
            this.$session.set('searchString', this.searchString)

            this.$router.push(`/sim/management/${simNumber}`)
        },
        showTags(ev) {
            let tagColumn = ev.target.parentElement
            let tagsList = tagColumn.querySelector('.tagslist')
            tagsList.classList.add('fixed-tagslist')
            tagsList.classList.add('tags-tooltip')
            let rect = ev.target.getBoundingClientRect()
            tagsList.style.top = rect.top + 20 + 'px'
            tagsList.style.left = rect.right + 20 + 'px'
            tagsList.style.maxWidth = '250px'
        },
        hideTags(ev) {
            let tagColumn = ev.target.parentElement
            let tagsList = tagColumn.querySelector('.tagslist')
            tagsList.classList.remove('fixed-tagslist')
            tagsList.classList.remove('tags-tooltip')
            tagsList.style.top = null
            tagsList.style.left = null
            tagsList.style.maxWidth = null
        },
        closeModalSim: function(ev) {
            this.numberSim = 0;
        },
        showBulkModal() {
            this.$refs.childBulkModal.showModal()
        },
        closeBulkModal() {
            this.visibilityBulkModal = 0;
        },
        changesSort: function(ev) {
            this.loadingSimList = true;
            this.sortSettings.sort = ev.target.getAttribute("aria-colindex");

            if (ev.target.getAttribute("aria-sort") == 'none') {
                document.querySelectorAll("table.table-managment thead th[aria-sort]").forEach(item => {
                    item.setAttribute("aria-sort", 'none')
                })
                ev.target.setAttribute("aria-sort", 'ascending')
                this.sortSettings.desc = false
            } else if (ev.target.getAttribute("aria-sort") == 'ascending') {
                ev.target.setAttribute("aria-sort", 'descending')
                this.sortSettings.desc = true
            } else if (ev.target.getAttribute("aria-sort") == 'descending') {
                ev.target.setAttribute("aria-sort", 'ascending')
                this.sortSettings.desc = false
            }
            this.getSimsList(true)
        },
        goToPage: function (ev) {
            document.querySelectorAll(".pagination .active").forEach(item => {
                item.classList.remove("active");
            })
            ev.target.parentNode.classList.add("active")
            this.sortSettings.page = ev.target.getAttribute("data-page-number");
            this.getSimsList(false)
        },
        prevPage: function () {
            this.sortSettings.page--;
            document.querySelectorAll(".pagination .active").forEach(item => {
                item.classList.remove("active");
            })
            document.querySelector('.pagination li[data-page-id="' + this.sortSettings.page + '"]').classList.add("active")
            this.getSimsList(false);
        },
        nextPage: function () {
            this.sortSettings.page++;
            document.querySelectorAll(".pagination .active").forEach(item => {
                item.classList.remove("active");
            })
            document.querySelector('.pagination li[data-page-id="' + this.sortSettings.page + '"]').classList.add("active")
            this.getSimsList(false);
        },
        sizePage: function () {
            this.loadingSimList = true;
            this.getSimsList(true);
        },
        readSimFile: function (ev) {
            if (ev.target)
                var f = ev.target.files[0];
            else
                var f = ev[0];
            var ext = f.name.slice(f.name.lastIndexOf("."));
            if (ext===".csv"){

                var ret = [];
                var r = new FileReader();
                var tempThis = this;
                r.onload = function(e) {
                    var ct = r.result;
                    var words;
                    ct.indexOf("\n") > 0 ? words = ct.split("\n") : words = ct.split(",");
                    var len = words.length;

                    for (let i = 0 ; i < len ; i++){
                        words[i] = words[i].replace(/\D/g,'');
                        words[i] != ""  ? ret.push(words[i]) : null;
                    }
                    tempThis.addSimChecked(ret);
                }
                r.readAsText(f);
            }
            else if (ext === '.txt') {


                var ret = [];
                if (ev.target)
                    var f = ev.target.files[0];
                else
                    var f = ev[0];
                if (f) {
                    var r = new FileReader();
                    var tempThis = this;
                    r.onload = function(e) {
                        var ct = r.result;
                        ct.indexOf("\n") > 0 ? ct = ct.split("\n") : ct = ct.split(",");
                        var len = ct.length;
                        for (var i = 0 ; i < len ; i++) {
                            ct[i] = ct[i].replace(/\D/g,'');
                        }
                        tempThis.addSimChecked(ct);
                    }
                    r.readAsText(f);
                } else {
                    alert("Failed to load file");
                }
            }
        },
        addSimChecked(sims) {
            let tempThis = this;
            sims.map(sim => {
                Axios.get(globalStore.data.restApiUrl + '/sims/' + sim)
                    .then(response => {
                        if (response.status == 200 && response['headers']['content-length'] > 2) {
                            this.selectedSims++;
                            tempThis.selectRow(response.data.response[0]['iccid'], response.data.response[0]['status'], 'false');
                        } else {
                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'Sim number not exist in base',
                                text: 'The sim number ' + sim + ' not exist in system.',
                                duration: 5000,
                            });
                        }

                    }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting sim details error',
                        text: 'We have error with get status of sims from file, please check if this sim number is right.',
                        duration: 5000,
                    });
                    console.log(error)
                })
            })
        },
        exportCsv () {
            this.loadingSimList = true;
            if (this.exportOption == 1)
                this.exportSelectedCSV();
            else if (this.exportOption == 2)
                this.exportPageCSV();
            else if(this.exportOption == 3)
                this.exportAllCSV();
            this.showfileFormatPopup = false;
        },
        exportXlsx () {
            this.loadingSimList = true;
            if (this.exportOption == 1)
                this.exportSelectedXLSX();
            else if (this.exportOption == 2)
                this.exportPageXLSX();
            else if(this.exportOption == 3)
                this.exportAllXLSX();
            this.showfileFormatPopup = false;
        },
        exportAllCSV() {
            Axios.get(globalStore.data.restApiUrl + '/sims/csv?allResults=true' + this.filters + this.searchString)
                .then(response => {
                    let csvContent = "data:text/csv;charset=utf-8," + response.data;
                    var fileLink = document.createElement('a');fileLink.href = csvContent;
                    fileLink.setAttribute('download', this.companyName+'.csv');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    setTimeout(() => {
                        this.loadingSimList = false;
                    }, 500)
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Error Exporting SIM Details - Contact Support',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        exportPageCSV() {
            Axios.get(globalStore.data.restApiUrl + '/sims/csv?page=' + this.sortSettings.page + '&size=' + this.sortSettings.size + '&desc=' + this.sortSettings.desc + '&sort=' + this.sortSettings.sort + this.searchString + this.filters)
                .then(response => {
                    let csvContent = "data:text/csv;charset=utf-8," + response.data;
                    var fileLink = document.createElement('a');fileLink.href = csvContent;
                    fileLink.setAttribute('download', this.companyName+'.csv');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    setTimeout(() => {
                        this.loadingSimList = false;
                    }, 500)
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Error Exporting SIM Details - Contact Support',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        exportSelectedCSV() {
            Axios.get(globalStore.data.restApiUrl + "/sims/csv" + '?selection=true')
                .then(response => {
                    let csvContent = "data:text/csv;charset=utf-8," + response.data;
                    var fileLink = document.createElement('a');fileLink.href = csvContent;
                    fileLink.setAttribute('download', this.companyName+'.csv');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Error Exporting SIM Details - Contact Support',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        exportAllXLSX() {
            Axios.get(globalStore.data.restApiUrl + "/sims/xlsx?allResults=true" + this.filters + this.searchString, {responseType: 'blob'})
                .then((response) => {
                    const fileLink = URL.createObjectURL(new Blob([response.data],
                        {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                        )
                    );
                    const link = document.createElement('a')
                    link.href = fileLink
                    link.setAttribute('download', this.companyName + '.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    setTimeout(() => {
                        this.loadingSimList = false;
                    }, 500)
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Error Exporting SIM Details - Contact Support',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        exportPageXLSX() {
            Axios.get(globalStore.data.restApiUrl + '/sims/xlsx?page=' + this.sortSettings.page + '&size=' + this.sortSettings.size + '&desc=' + this.sortSettings.desc + '&sort=' + this.sortSettings.sort + this.searchString + this.filters, {responseType: 'blob'})
                .then((response) => {
                    const fileLink = URL.createObjectURL(new Blob([response.data],
                        {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                        )
                    );
                    const link = document.createElement('a')
                    link.href = fileLink
                    link.setAttribute('download', this.companyName + '.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    setTimeout(() => {
                        this.loadingSimList = false;
                    }, 500)
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Error Exporting SIM Details - Contact Support',
                    duration: 3000,
                });
                console.log(error);
            });


        },
        exportSelectedXLSX() {
            Axios.get(
                globalStore.data.restApiUrl + "/sims/xlsx" + '?selection=true',
                {responseType: 'blob'}
            )
                .then((response) => {
                    const fileLink = URL.createObjectURL(new Blob([response.data],
                        {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                        )
                    );
                    const link = document.createElement('a')
                    link.href = fileLink
                    link.setAttribute('download', this.companyName + '.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    setTimeout(() => {
                        this.loadingSimList = false;
                    }, 500)
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'SIMs export went wrong',
                    text: 'Error Exporting SIM Details - Contact Support',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        getCustomFields() {
            Axios.get(globalStore.data.restApiUrl + '/custom-fields')
                .then( response => {
                    this.customFields = response.data.hidden;
                    if (!this.customFields) {
                        response.data.fields.forEach(field => {
                            if (field.index == 1) {
                                this.custom1 = field.label;
                            } else if (field.index == 2) {
                                this.custom2 = field.label;
                            }
                        })
                    }
                })
            },
        clickFilters() {
            if (this.filtersShown) {
                this.cancelFilters();
            } else {
                this.filtersShown = true;
                this.setInitialFilters()
            }
        },
        runFilters() {
            this.loadingSimList = true;
            this.setFilters();
            this.getSimsList(true)
            this.filtersShown = false;
            this.setInitialFilters()
        },
        getTagsList() {
            Axios.get(globalStore.data.restApiUrl + "/tags?sort=" + this.searchTag.sort + "&desc=" + this.searchTag.desc)
                .then(response => {
                    let tags = response.data
                    this.tagsList = []
                    if (this.selectedTags.length > 0) {
                        for (let tag of tags) {
                            let selected = false
                            for(let item of this.selectedTags) {
                                if (item.id == tag.id) {
                                    selected = true
                                }
                            }
                            let template = {
                                id: tag.id,
                                label: tag.label,
                                selected: selected
                            }
                            this.tagsList.push(template)
                        }
                    } else {
                        for (let tag of tags) {
                            let template = {
                                id: tag.id,
                                label: tag.label,
                                selected: false
                            }
                            this.tagsList.push(template)
                        }
                    }
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Getting tags failed.',
                        text: 'Error has occured during getting tags, please contact support.',
                        duration: 3000,
                    });
                    console.log(error)
                })
        },
        selectTag(tag) {
            tag.selected = true
            this.selectedTags.push({
                id: tag.id,
                label: tag.label,
                selected: true
            })
            if (this.selectedTags.length  == 0) {
                this.selectedTagsCounter = ''
            } else if (this.selectedTags.length == 1) {
                this.selectedTagsCounter = this.selectedTags.length + ' tag selected'
            } else if (this.selectedTags.length > 1) {
                this.selectedTagsCounter =  this.selectedTags.length + ' tags selected'
            }
        },
        deselectTag(tag) {
            for (let item of this.tagsList) {
                if (item.id == tag.id) {
                    item.selected = false
                }
            }

            for (let i = 0; i < this.selectedTags.length; i ++) {
                if (tag.id ==  this.selectedTags[i].id) {
                    this.selectedTags.splice(i, 1);
                }
            }

            if (this.selectedTags.length  == 0) {
                this.selectedTagsCounter = ''
            } else if (this.selectedTags.length == 1) {
                this.selectedTagsCounter = this.selectedTags.length + ' tag selected'
            } else if (this.selectedTags.length > 1) {
                this.selectedTagsCounter =  this.selectedTags.length + ' tags selected'
            }
        },
        searchTags(tag) {
            if (tag.label.toLowerCase().indexOf(this.filtersSearch.toLowerCase()) < 0) {
                return true
            } else {
                return false
            }
        },
        setMostUsed() {
            if (this.searchTag.sort == 2){
                this.searchTag.desc = !this.searchTag.desc;
            } else {
                this.searchTag.sort = 2;
                this.searchTag.desc = false;
            }
            this.getTagsList();
        },
        setAlpha(){
            if (this.searchTag.sort == 1) {
                this.searchTag.desc = !this.searchTag.desc;
            } else {
                this.searchTag.sort = 1;
                this.searchTag.desc = false;
            }
            this.getTagsList();
        },
        switchCarrier(carrierId) {
            if (carrierId == 1 && this.simonFilter == false) {
                this.selectedPlans = this.selectedPlans.filter( plan => plan.carrierId != 1)
            }
            if (carrierId == 2 && this.tmobileFilter == false) {
                this.selectedPlans = this.selectedPlans.filter( plan => plan.carrierId != 2)
            }
            if (carrierId == 3 && this.vodafoneFilter == false) {
                this.selectedPlans = this.selectedPlans.filter( plan => plan.carrierId != 3)
            }
            this.countPlans();
            this.getPlansList();
        },
        switchStatus(carrierId) {
            if (carrierId == 1) {
                let initialSimon = this.simonFilter;
                if (this.statuses.simon.active || this.statuses.simon.activeReady || this.statuses.simon.suspended || this.statuses.simon.simBank || this.statuses.simon.inactive) {
                    this.simonFilter = true
                } else {
                    this.simonFilter = false
                }

                if (this.statuses.simon.active && this.statuses.simon.activeReady && this.statuses.simon.suspended && this.statuses.simon.simBank && this.statuses.simon.inactive) {
                    this.statuses.simon.all = true
                } else {
                    this.statuses.simon.all = false
                }

                if (initialSimon != this.simonFilter) {
                    this.countPlans();
                    this.getPlansList();
                }
            } else if (carrierId == 2) {
                let initialTmobile = this.tmobileFilter;
                if (this.statuses.tmobile.active || this.statuses.tmobile.suspended || this.statuses.tmobile.inactive) {
                    this.tmobileFilter = true
                } else {
                    this.tmobileFilter = false
                }
                if (this.statuses.tmobile.active && this.statuses.tmobile.suspended && this.statuses.tmobile.inactive) {
                    this.statuses.tmobile.all = true
                } else {
                    this.statuses.tmobile.all = false
                }
                if (initialTmobile != this.tmobileFilter) {
                    this.countPlans();
                    this.getPlansList();
                }
            } else if (carrierId == 3) {
                let initialVodafone = this.vodafoneFilter;
                if (this.statuses.vodafone.activeLive || this.statuses.vodafone.activeSleep || this.statuses.vodafone.activeReady || this.statuses.vodafone.activeSuspended || this.statuses.vodafone.activeTest || this.statuses.vodafone.activeStandby || this.statuses.vodafone.inactiveStopped || this.statuses.vodafone.inactive || this.statuses.vodafone.terminated) {
                    this.vodafoneFilter = true
                } else {
                    this.vodafoneFilter = false
                }
                if (this.statuses.vodafone.activeLive && this.statuses.vodafone.activeSleep && this.statuses.vodafone.activeReady && this.statuses.vodafone.activeSuspended && this.statuses.vodafone.activeTest && this.statuses.vodafone.activeStandby && this.statuses.vodafone.inactiveStopped && this.statuses.vodafone.inactive && this.statuses.vodafone.terminated) {
                    this.statuses.vodafone.all = true
                } else {
                    this.statuses.vodafone.all = false
                }
                if (initialVodafone != this.vodafoneFilter) {
                    this.countPlans();
                    this.getPlansList();
                }
            } else if (carrierId == 4) {
                let initialKore = this.initialKore;
                if (this.statuses.kore.active || this.statuses.kore.activeTest || this.statuses.kore.activeReady || this.statuses.kore.suspended || this.statuses.kore.suspendedWithCharge || this.statuses.kore.terminated || this.statuses.kore.pendingScrap || this.statuses.kore.deactivated) {
                    this.koreFilter = true
                } else {
                    this.koreFilter = false
                }
                if (this.statuses.kore.active && this.statuses.kore.activeTest && this.statuses.kore.activeReady && this.statuses.kore.suspended && this.statuses.kore.suspendedWithCharge && this.statuses.kore.terminated && this.statuses.kore.pendingScrap && this.statuses.kore.deactivated) {
                    this.statuses.kore.all = true
                } else {
                    this.statuses.kore.all = false
                }
                if (initialKore != this.initialKore) {
                    this.countPlans();
                    this.getPlansList();
                }
            }
        },
        selectAllStatuses(carrierId) {
            if (carrierId == 1) {
                let initialSimon = this.simonFilter;
                this.simonFilter = true

                this.statuses.simon.active = true
                this.statuses.simon.activeReady = true
                this.statuses.simon.suspended = true
                this.statuses.simon.simBank = true
                this.statuses.simon.inactive = true

                if (initialSimon == false) {
                    this.countPlans();
                    this.getPlansList();
                }
            } else if (carrierId == 2) {
                let initialTmobile = this.tmobileFilter;
                this.tmobileFilter = true

                this.statuses.tmobile.active = true
                this.statuses.tmobile.suspended = true
                this.statuses.tmobile.inactive = true

                if (initialTmobile == false) {
                    this.countPlans();
                    this.getPlansList();
                }
            } else if (carrierId == 3) {
                let initialVodafone = this.vodafoneFilter;
                this.vodafoneFilter = true

                this.statuses.vodafone.activeSuspended = true
                this.statuses.vodafone.activeTest = true
                this.statuses.vodafone.activeStandby = true
                this.statuses.vodafone.inactiveStopped = true
                this.statuses.vodafone.inactive = true
                this.statuses.vodafone.terminated = true
                this.statuses.vodafone.activeReady = true
                this.statuses.vodafone.activeSleep = true
                this.statuses.vodafone.activeLive = true

                if (initialVodafone == false) {
                    this.countPlans();
                    this.getPlansList();
                }
            }
        },
        unselectAllStatuses(carrierId) {
            if (carrierId == 1) {
                let initialSimon = this.simonFilter;
                this.simonFilter = false

                this.statuses.simon.active = false
                this.statuses.simon.activeReady = false
                this.statuses.simon.suspended = false
                this.statuses.simon.simBank = false
                this.statuses.simon.inactive = false

                if (initialSimon == true) {
                    this.countPlans();
                    this.getPlansList();
                }
            } else if (carrierId == 2) {
                let initialTmobile = this.tmobileFilter;
                this.tmobileFilter = false

                this.statuses.tmobile.active = false
                this.statuses.tmobile.suspended = false
                this.statuses.tmobile.inactive = false

                if (initialTmobile == true) {
                    this.countPlans();
                    this.getPlansList();
                }
            } else if (carrierId == 3) {
                let initialVodafone = this.vodafoneFilter;
                this.vodafoneFilter = false

                this.statuses.vodafone.activeSuspended = false
                this.statuses.vodafone.activeTest = false
                this.statuses.vodafone.activeStandby = false
                this.statuses.vodafone.inactiveStopped = false
                this.statuses.vodafone.inactive = false
                this.statuses.vodafone.terminated = false
                this.statuses.vodafone.activeReady = false
                this.statuses.vodafone.activeSleep = false
                this.statuses.vodafone.activeLive = false

                if (initialVodafone == true) {
                    this.countPlans();
                    this.getPlansList();
                }
            }
        },
        getPlansList() {
            this.plansList = [];

            this.plansParsed = {
                A: [],
                B: [],
                C: [],
                D: [],
                E: [],
                F: [],
                G: [],
                H: [],
                I: [],
                J: [],
                K: [],
                L: [],
                M: [],
                N: [],
                O: [],
                P: [],
                Q: [],
                R: [],
                S: [],
                T: [],
                U: [],
                V: [],
                W: [],
                X: [],
                Y: [],
                Z: [],
                misc: []
            }

            if (this.simonCarrierAvailable && this.simonFilter) {
                Axios.get(globalStore.data.restApiUrl + "/account/rate-plans")
                    .then(response => {
                        for (let plan of response.data.response) {
                            let template = {
                                id: plan.ratePlanId,
                                name: plan.planName,
                                carrierId: plan.carrierId,
                                selected: false,
                                dataLimit: plan.dataLimit.mbLimit
                            }
                            this.assignAlpha(template)
                            //this.plansList.push(template)
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting Simon IoT plans failed.',
                            text: 'Error has occured during getting Simon IoT plans, please contact support.',
                            duration: 3000,
                        });
                        console.log(error)
                    })
            }
            if (this.tmobileCarrierAvailable && this.tmobileFilter) {
                Axios.get(`${globalStore.data.restApiUrl}/account/rate-plans?carrierId=2`)
                .then(response => {
                    for (let plan of response.data.response) {
                        let template = {
                            id: plan.ratePlanId,
                            name: plan.planName,
                            carrierId: plan.carrierId,
                            selected: false,
                            dataLimit: null
                        }
                        this.assignAlpha(template)
                        //this.plansList.push(template)
                    }
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Getting T-Mobile plans failed.',
                        text: 'Error has occured during getting T-Mobile plans, please contact support.',
                        duration: 3000,
                    });
                    console.log(error)
                })
            }
            if (this.vodafoneCarrierAvailable && this.vodafoneFilter) {
                Axios.get(`${globalStore.data.restApiUrl}/account/rate-plans?carrierId=3`)
                    .then(response => {
                        for (let plan of response.data.response) {
                            let template = {
                                id: plan.ratePlanId,
                                name: plan.planName,
                                carrierId: plan.carrierId,
                                selected: false,
                                dataLimit: plan.dataLimit.mbLimit
                            }
                            this.assignAlpha(template)
                            //this.plansList.push(template)
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting Simon IoT plans failed.',
                            text: 'Error has occured during getting Vodafone plans, please contact support.',
                            duration: 3000,
                        });
                        console.log(error)
                    })
            }
            if (this.koreCarrierAvailable && this.koreFilter) {
                Axios.get(`${globalStore.data.restApiUrl}/account/rate-plans?carrierId=4`)
                    .then(response => {
                        for (let plan of response.data.response) {
                            let template = {
                                id: plan.ratePlanId,
                                name: plan.planName,
                                carrierId: plan.carrierId,
                                selected: false,
                                dataLimit: 500
                            }
                            this.assignAlpha(template)
                            //this.plansList.push(template)
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting Simon IoT plans failed.',
                            text: 'Error has occured during getting Kore plans, please contact support.',
                            duration: 3000,
                        });
                        console.log(error)
                    })
            }
        },
        assignAlpha(plan) {
            if (plan.name.charAt(0).toLowerCase() == 'a') {
                this.plansParsed.A.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'b') {
                this.plansParsed.B.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'c') {
                this.plansParsed.C.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'd') {
                this.plansParsed.D.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'e') {
                this.plansParsed.E.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'f') {
                this.plansParsed.F.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'g') {
                this.plansParsed.G.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'h') {
                this.plansParsed.H.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'i') {
                this.plansParsed.I.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'j') {
                this.plansParsed.J.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'k') {
                this.plansParsed.K.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'l') {
                this.plansParsed.L.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'm') {
                this.plansParsed.M.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'n') {
                this.plansParsed.N.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'o') {
                this.plansParsed.O.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'p') {
                this.plansParsed.P.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'q') {
                this.plansParsed.Q.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'r') {
                this.plansParsed.R.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 's') {
                this.plansParsed.S.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 't') {
                this.plansParsed.T.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'u') {
                this.plansParsed.U.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'v') {
                this.plansParsed.V.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'w') {
                this.plansParsed.W.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'x') {
                this.plansParsed.X.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'y') {
                this.plansParsed.Y.push(plan)
            } else if (plan.name.charAt(0).toLowerCase() == 'z') {
                this.plansParsed.Z.push(plan)
            } else {
                this.plansParsed.misc.push(plan)
            }
        },
        searchPlans(plan) {
            if (this.filtersSearch != '') {
                if (plan.name.toLowerCase().indexOf(this.filtersSearch.toLowerCase()) > -1) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },
        searchThroughPlans(plans) {
            let counter = 0;
            if (plans.length) {
                for (let plan of plans) {
                    if (this.searchPlans(plan) && this.filterPlans(plan)) {
                        counter++;
                    }
                }
                if (counter == 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        selectAll(carrier) {
            if (carrier == 'simon') {
                if (this.statuses.simon.all) {
                    this.statuses.simon.active = true
                    this.statuses.simon.activeReady = true
                    this.statuses.simon.suspended = true
                    this.statuses.simon.simBank = true
                    this.statuses.simon.inactive = true
                } else {
                    this.statuses.simon.active = false
                    this.statuses.simon.activeReady = false
                    this.statuses.simon.suspended = false
                    this.statuses.simon.simBank = false
                    this.statuses.simon.inactive = false
                }
            } else if (carrier == 'tmobile') {
                if (this.statuses.tmobile.all) {
                    this.statuses.tmobile.active = true
                    this.statuses.tmobile.suspended = true
                    this.statuses.tmobile.inactive = true
                } else {
                    this.statuses.tmobile.active = false
                    this.statuses.tmobile.suspended = false
                    this.statuses.tmobile.inactive = false
                }
            } else if (carrier == 'vodafone') {
                if (this.statuses.vodafone.all) {
                    this.statuses.vodafone.activeLive = true
                    this.statuses.vodafone.activeSleep = true
                    this.statuses.vodafone.activeReady = true
                    this.statuses.vodafone.activeSuspended = true
                    this.statuses.vodafone.activeTest = true
                    this.statuses.vodafone.activeStandby = true
                    this.statuses.vodafone.inactiveStopped = true
                    this.statuses.vodafone.terminated = true
                    this.statuses.vodafone.inactive = true
                } else {
                    this.statuses.vodafone.activeLive = false
                    this.statuses.vodafone.activeSleep = false
                    this.statuses.vodafone.activeReady = false
                    this.statuses.vodafone.activeSuspended = false
                    this.statuses.vodafone.activeTest = false
                    this.statuses.vodafone.activeStandby = false
                    this.statuses.vodafone.inactiveStopped = false
                    this.statuses.vodafone.terminated = false
                    this.statuses.vodafone.inactive = false
                }
            } else if (carrier == 'kore') {
                if (this.statuses.kore.all) {
                    this.statuses.kore.active = true
                    this.statuses.kore.activeTest = true
                    this.statuses.kore.activeReady = true
                    this.statuses.kore.suspended = true
                    this.statuses.kore.suspendedWithCharge = true
                    this.statuses.kore.terminated = true
                    this.statuses.kore.pendingScrap = true
                    this.statuses.kore.deactivated = true
                } else {
                    this.statuses.kore.active = false
                    this.statuses.kore.activeTest = false
                    this.statuses.kore.activeReady = false
                    this.statuses.kore.suspended = false
                    this.statuses.kore.suspendedWithCharge = false
                    this.statuses.kore.terminated = false
                    this.statuses.kore.pendingScrap = false
                    this.statuses.kore.deactivated = false
                }
            }
        },
        filterStatuses(status) {
            if (this.filtersSearch != '') {
                if (status.toLowerCase().indexOf(this.filtersSearch.toLowerCase()) < 0) {
                    return false
                } else {
                    return true
                }
            } else {
                return true
            }
        },
        filterPlans(plan) {
            if (this.plansFilterSelected == 0) {
                return true
            } else if (this.plansFilterSelected == 1) {
                if (plan.dataLimit != null && plan.dataLimit < 1024) {
                    return true
                } else {
                    return false
                }
            } else if (this.plansFilterSelected == 2) {
                if (plan.dataLimit != null && plan.dataLimit >= 1024) {
                    return true
                } else {
                    return false
                }
            } else if (this.plansFilterSelected == 3) {
                if (plan.carrierId == 1) {
                    return true
                } else {
                    return false
                }
            } else if (this.plansFilterSelected == 4) {
                if (plan.carrierId == 2) {
                    return true
                } else {
                    return false
                }
            } else if (this.plansFilterSelected == 5) {
                if (plan.carrierId == 3) {
                    return true
                } else {
                    return false
                }
            } else if (this.plansFilterSelected == 6) {
                if (plan.carrierId == 4) {
                    return true
                } else {
                    return false
                }
            }
        },
        setPlansFilter(filter) {
            this.plansFilterSelected = filter;
        },
        setDefaultFilters() {
            if (this.simonCarrierAvailable) {
                this.simonFilter = true

                this.statuses.simon = {
                    all: true,
                    active: true,
                    suspended: true,
                    simBank: true,
                    inactive: true
                }
            }

            if (this.tmobileCarrierAvailable) {
                this.tmobileFilter = true

                this.statuses.tmobile = {
                    all: true,
                    active: true,
                    suspended: true,
                    inactive: true
                }
            }

            if (this.vodafoneCarrierAvailable) {
                this.vodafoneFilter = true
                this.statuses.vodafone = {
                    all: true,
                    activeLive: true,
                    activeSleep: true,
                    activeReady: true,
                    activeSuspended: true,
                    activeTest: true,
                    activeStandby: true,
                    inactiveStopped: true,
                    terminated: true,
                    inactive: true
                }
            }

            if (this.koreCarrierAvailable) {
                this.koreFilter = true
                this.statuses.kore = {
                    all: true,
                    active: true,
                    activeTest: true,
                    activeReady: true,
                    suspended: true,
                    suspendedWithCharge: true,
                    pendingScrap: true,
                    terminated: true,
                    deactivated: true
                }
            }

            for (let plans in this.plansParsed) {
                for (let plan of this.plansParsed[plans]) {
                    plan.selected = false;
                }
            }
            this.selectedPlans = [];

            for (let tag of this.tagsList) {
                tag.selected = false
            }
            this.selectedTags = []
        },
        setFilters() {
            this.filters = '&applyStatusesFiltering=true';

            if (this.simonCarrierAvailable) {
                if (this.statuses.simon.active || this.statuses.simon.activeReady || this.statuses.simon.suspended || this.statuses.simon.simBank || this.statuses.simon.inactive) {
                    if (this.statuses.simon.active) {
                        this.filters = this.filters + '&genesisStatuses=ACTIVE'
                    }
                    if (this.statuses.simon.activeReady) {
                        this.filters = this.filters + '&genesisStatuses=ACTIVE_READY'
                    }
                    if (this.statuses.simon.suspended) {
                        this.filters = this.filters + '&genesisStatuses=SUSPENDED'
                    }
                    if (this.statuses.simon.simBank) {
                        this.filters = this.filters + '&genesisStatuses=SIM_BANK'
                    }
                    if (this.statuses.simon.inactive) {
                        this.filters = this.filters + '&genesisStatuses=INACTIVE'
                    }
                }
            }

            if (this.tmobileCarrierAvailable) {
                if (this.statuses.tmobile.active || this.statuses.tmobile.suspended || this.statuses.tmobile.inactive) {
                    if (this.statuses.tmobile.active) {
                        this.filters = this.filters + '&magentaStatuses=ACTIVE'
                    }
                    if (this.statuses.tmobile.suspended) {
                        this.filters = this.filters + '&magentaStatuses=SUSPENDED'
                    }
                    if (this.statuses.tmobile.inactive) {
                        this.filters = this.filters + '&magentaStatuses=INACTIVE'
                    }
                }
            }
            if (this.vodafoneCarrierAvailable) {
                if (this.statuses.vodafone.activeLive || this.statuses.vodafone.activeSleep || this.statuses.vodafone.activeReady || this.statuses.vodafone.activeSuspended || this.statuses.vodafone.activeTest || this.statuses.vodafone.activeStandby || this.statuses.vodafone.inactiveStopped || this.statuses.vodafone.inactive || this.statuses.vodafone.terminated) {
                    if (this.statuses.vodafone.activeLive) {
                        this.filters = this.filters + '&vodafoneStatuses=ACTIVE_LIVE'
                    }
                    if (this.statuses.vodafone.activeSleep) {
                        this.filters = this.filters + '&vodafoneStatuses=ACTIVE_SLEEP'
                    }
                    if (this.statuses.vodafone.activeReady) {
                        this.filters = this.filters + '&vodafoneStatuses=ACTIVE_READY'
                    }
                    if (this.statuses.vodafone.activeSuspended) {
                        this.filters = this.filters + '&vodafoneStatuses=ACTIVE_SUSPEND'
                    }
                    if (this.statuses.vodafone.activeTest) {
                        this.filters = this.filters + '&vodafoneStatuses=ACTIVE_TEST'
                    }
                    if (this.statuses.vodafone.activeStandby) {
                        this.filters = this.filters + '&vodafoneStatuses=ACTIVE_STANDBY'
                    }
                    if (this.statuses.vodafone.inactiveStopped) {
                        this.filters = this.filters + '&vodafoneStatuses=INACTIVE_STOPPED'
                    }
                    if (this.statuses.vodafone.inactive) {
                        this.filters = this.filters + '&vodafoneStatuses=INACTIVE'
                    }
                    if (this.statuses.vodafone.terminated) {
                        this.filters = this.filters + '&vodafoneStatuses=TERMINATED'
                    }
                }
            }
            if (this.koreCarrierAvailable) {
                if (this.statuses.kore.active || this.statuses.kore.activeTest || this.statuses.kore.activeReady || this.statuses.kore.suspended || this.statuses.kore.suspendedWithCharge || this.statuses.kore.pendingScrap || this.statuses.kore.terminated || this.statuses.kore.deactivated) {
                    if (this.statuses.kore.active) {
                        this.filters = this.filters + '&koreStatuses=ACTIVE'
                    }
                    if (this.statuses.kore.activeTest) {
                        this.filters = this.filters + '&koreStatuses=ACTIVE_TEST'
                    }
                    if (this.statuses.kore.activeReady) {
                        this.filters = this.filters + '&koreStatuses=ACTIVE_READY'
                    }
                    if (this.statuses.kore.suspended) {
                        this.filters = this.filters + '&koreStatuses=SUSPENDED'
                    }
                    if (this.statuses.kore.suspendedWithCharge) {
                        this.filters = this.filters + '&koreStatuses=SUSPEND_WITH_CHARGE'
                    }
                    if (this.statuses.kore.pendingScrap) {
                        this.filters = this.filters + '&koreStatuses=PENDING_SCRAP'
                    }
                    if (this.statuses.kore.terminated) {
                        this.filters = this.filters + '&koreStatuses=TERMINATED'
                    }
                    if (this.statuses.kore.deactivated) {
                        this.filters = this.filters + '&koreStatuses=DEACTIVATED'
                    }
                }
            }

            if (this.selectedTags.length > 0) {
                for (let tag of this.selectedTags) {
                    this.filters = this.filters + '&tagIds=' + tag.id
                }
            }

            for (let plans in this.plansParsed) {
                for (let plan of this.plansParsed[plans]) {
                    if (plan.selected) {
                        if (plan.carrierId == 1) {
                            this.filters = this.filters + '&templateIds=' + plan.id
                        } else {
                            this.filters = this.filters + '&ratePlanIds=' + plan.id
                        }
                    }
                }
            }
        },
        selectPlan(plan) {
            if (plan.selected) {
                this.selectedPlans.push(plan)
                this.countPlans()
            } else {
                for (let i = 0; i < this.selectedPlans.length ; i++) {
                    if (this.selectedPlans[i].id == plan.id) {
                        this.selectedPlans.splice(i, 1);
                        this.countPlans()
                        return false
                    }
                }
            }
        },
        countPlans() {
            if (this.selectedPlans.length == 0) {
                this.selectedPlansCounter = ''
            } else if (this.selectedPlans.length == 1) {
                this.selectedPlansCounter = '1 plan selected'
            } else {
                this.selectedPlansCounter = this.selectedPlans.length + ' plans selected'
            }
        },
        deselectPlan(plan) {
            for (let i = 0; i < this.selectedPlans.length ; i++) {
                if (this.selectedPlans[i].id == plan.id) {
                    this.selectedPlans.splice(i, 1);
                    this.countPlans()
                }
            }

            for (let plans in this.plansParsed) {
                for (let item of this.plansParsed[plans]) {
                    if (item.id == plan.id) {
                        item.selected = false;
                        return false;
                    }
                }
            }
        },
        setInitialFilters() {
            this.initialFilters = {
                simonFilter: this.simonFilter,
                tmobileFilter: this.tmobileFilter,
                vodafoneFilter: this.vodafoneFilter,
                koreFilter: this.koreFilter,
                selectedTags: [],
                selectedPlans: [],
                statuses: {
                    simon: {
                        all: this.statuses.simon.all,
                        active: this.statuses.simon.active,
                        activeReady: this.statuses.simon.activeReady,
                        suspended: this.statuses.simon.suspended,
                        simBank: this.statuses.simon.simBank,
                        inactive: this.statuses.simon.inactive
                    },
                    tmobile: {
                        all: this.statuses.tmobile.all,
                        active: this.statuses.tmobile.active,
                        suspended: this.statuses.tmobile.suspended,
                        inactive: this.statuses.tmobile.inactive
                    },
                    vodafone: {
                        all: this.statuses.vodafone.all,
                        activeLive: this.statuses.vodafone.activeLive,
                        activeSleep: this.statuses.vodafone.activeSleep,
                        activeReady: this.statuses.vodafone.activeReady,
                        activeSuspended: this.statuses.vodafone.activeSuspended,
                        activeTest: this.statuses.vodafone.activeTest,
                        activeStandby: this.statuses.vodafone.activeStandby,
                        inactiveStopped: this.statuses.vodafone.inactiveStopped,
                        terminated: this.statuses.vodafone.terminated,
                        inactive: this.statuses.vodafone.inactive
                    },
                    kore: {
                        all: this.statuses.kore.all,
                        active: this.statuses.kore.active,
                        activeTest: this.statuses.kore.activeTest,
                        activeReady: this.statuses.kore.activeReady,
                        suspended: this.statuses.kore.suspended,
                        suspendedWithCharge: this.statuses.kore.suspendedWithCharge,
                        pendingScrap: this.statuses.kore.pendingScrap,
                        terminated: this.statuses.kore.terminated,
                        deactivated: this.statuses.kore.deactivated
                    }
                }
            }

            for (let tag in this.selectedTags) {
                this.initialFilters.selectedTags.push(tag.id)
            }

            for (let plan in this.selectedPlans) {
                this.initialFilters.selectedPlans.push(plan.id)
            }
        },
        clearFilters() {
            this.filtersSearch = ''
        },
        cancelFilters() {
            this.filtersShown = false;

            this.simonFilter = this.initialFilters.simonFilter;
            this.tmobileFilter = this.initialFilters.tmobileFilter;
            this.vodafoneFilter = this.initialFilters.vodafoneFilter;
            this.koreFilter = this.initialFilters.koreFilter;

            this.statuses = {
                simon: {
                    all: this.initialFilters.statuses.simon.all,
                    active: this.initialFilters.statuses.simon.active,
                    activeReady: this.initialFilters.statuses.simon.activeReady,
                    suspended: this.initialFilters.statuses.simon.suspended,
                    simBank: this.initialFilters.statuses.simon.simBank,
                    inactive: this.initialFilters.statuses.simon.inactive
                },
                tmobile: {
                    all: this.initialFilters.statuses.tmobile.all,
                    active: this.initialFilters.statuses.tmobile.active,
                    suspended: this.initialFilters.statuses.tmobile.suspended,
                    inactive: this.initialFilters.statuses.tmobile.inactive
                },
                vodafone: {
                    all: this.initialFilters.statuses.vodafone.all,
                    activeLive: this.initialFilters.statuses.vodafone.activeLive,
                    activeSleep: this.initialFilters.statuses.vodafone.activeSleep,
                    activeReady: this.initialFilters.statuses.vodafone.activeReady,
                    activeSuspended: this.initialFilters.statuses.vodafone.activeSuspended,
                    activeTest: this.initialFilters.statuses.vodafone.activeTest,
                    activeStandby: this.initialFilters.statuses.vodafone.activeStandby,
                    inactiveStopped: this.initialFilters.statuses.vodafone.inactiveStopped,
                    terminated: this.initialFilters.statuses.vodafone.terminated,
                    inactive: this.initialFilters.statuses.vodafone.inactive
                },
                kore: {
                    all: this.initialFilters.statuses.kore.all,
                    active: this.initialFilters.statuses.kore.active,
                    activeTest: this.initialFilters.statuses.kore.activeTest,
                    activeReady: this.initialFilters.statuses.kore.activeReady,
                    suspended: this.initialFilters.statuses.kore.suspended,
                    suspendedWithCharge: this.initialFilters.statuses.kore.suspendedWithCharge,
                    pendingScrap: this.initialFilters.statuses.kore.pendingScrap,
                    terminated: this.initialFilters.statuses.kore.terminated,
                    deactivated: this.initialFilters.statuses.kore.deactivated
                }
            }

            this.selectedTags = []
            for (let tag of this.tagsList) {
                if (this.initialFilters.selectedTags.indexOf(tag.id) > -1) {
                    tag.selected = true
                    this.selectedTags.push(tag)
                } else {
                    tag.selected = false
                }
            }

            this.selectedPlans = []
            for (let plans in this.plansParsed) {
                for (let plan of this.plansParsed[plans]) {
                    if (this.initialFilters.selectedPlans.indexOf(plan.id) > -1) {
                        plan.selected = true
                        this.selectedPlans.push(plan)
                    } else {
                        plan.selected = false
                    }
                }
            }
            this.historicalSims = this.initialFilters.historicalSims ? true : false
        },
        showMobileElements() {
            const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

            if (width < 992) {
                this.mobileVisible = true;
            } else {
                this.mobileVisible = false;
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.name == 'SIM details') {
                vm.sortSettings = vm.$session.get('simManagementSortSettings');
                let test = vm.$session.get('simManagementSortSettings');
                if (Boolean(vm.sortSettings)) {
                    vm.$session.remove('simManagementSortSettings')
                } else {
                    vm.sortSettings = {
                        page: 1,
                        size: 40,
                        sort: 1,
                        desc: true
                    }
                }
                if (vm.$session.get('simonFilter')) {
                    vm.simonFilter = vm.$session.get('simonFilter')
                }
                if (vm.$session.get('tmobileFilter')) {
                    vm.tmobileFilter = vm.$session.get('tmobileFilter')
                }
                if (vm.$session.get('vodafoneFilter')) {
                    vm.vodafoneFilter = vm.$session.get('vodafoneFilter')
                }
                if (vm.$session.get('statuses')) {
                    vm.statuses = vm.$session.get('statuses')
                }
                if (vm.$session.get('selectedTags')) {
                    vm.tagsList = vm.$session.get('tags')
                    vm.selectedTags = vm.$session.get('selectedTags')
                }
                if (vm.$session.get('selectedPlans')) {
                    vm.selectedPlans = vm.$session.get('selectedPlans')
                    vm.plansParsed = vm.$session.get('plansParsed')
                }
                if (vm.$session.get('searchString')) {
                    vm.searchString = vm.$session.get('searchString')
                }
                if (vm.$session.get('filter')) {
                    vm.filter = vm.$session.get('filter')
                }
                if (vm.$session.get('filters')) {
                    vm.filters = vm.$session.get('filters')
                }
                if (vm.$session.get('paginationCount')) {
                    vm.paginationCount = vm.$session.get('paginationCount')
                }
                vm.getSimsList(false)
            } else {
                if (vm.$session.get('simManagementSortSettings')) {
                    vm.$session.remove('simManagementSortSettings')
                }
                if (vm.$session.get('simonFilter')) {
                    vm.$session.remove('simonFilter')
                }
                if (vm.$session.get('tmobileFilter')) {
                    vm.$session.remove('tmobileFilter')
                }
                if (vm.$session.get('vodafoneFilter')) {
                    vm.$session.remove('vodafoneFilter')
                }
                if (vm.$session.get('statuses')) {
                    vm.$session.remove('statuses')
                }
                if (vm.$session.get('selectedTags')) {
                    vm.$session.remove('tags')
                    vm.$session.remove('selectedTags')
                }
                if (vm.$session.get('selectedPlans')) {
                    vm.$session.remove('plansParsed')
                    vm.$session.remove('selectedPlans')
                }
                if (vm.$session.get('searchString')) {
                    vm.$session.remove('searchString')
                }
                if (vm.$session.get('filter')) {
                    vm.$session.remove('filter')
                }
                if (vm.$session.get('filters')) {
                    vm.$session.remove('filters')
                }
                if (vm.$session.get('paginationCount')) {
                    vm.$session.remove('paginationCount')
                }
                vm.getSimsList(true)
            }
        })
    },
    mounted: function() {
        this.showMobileElements()
        this.getCustomFields();

        this.companyName = this.$cookies.get('companyName') ? this.$cookies.get('companyName') : this.$session.get('companyName')


        if (this.$cookies.get('simonCarrierAvailable') == 'true' || this.$session.get('simonCarrierAvailable')) {
            this.simonCarrierAvailable = true
            this.simonFilter = true
        } else {
            this.simonCarrierAvailable = false
            this.simonFilter = false
        }

        if (this.$cookies.get('tmobileCarrierAvailable') == 'true' || this.$session.get('tmobileCarrierAvailable')) {
            this.tmobileCarrierAvailable = true
            this.tmobileFilter = true
        } else {
            this.tmobileCarrierAvailable = false
            this.tmobileFilter = false
        }

        if (this.$cookies.get('vodafoneCarrierAvailable') == 'true' || this.$session.get('vodafoneCarrierAvailable')) {
            this.vodafoneCarrierAvailable = true
            this.vodafoneFilter = true
        } else {
            this.vodafoneCarrierAvailable = false
            this.vodafoneFilter = false
        }

        if (this.$cookies.get('koreCarrierAvailable') == 'true' || this.$session.get('koreCarrierAvailable')) {
            this.koreCarrierAvailable = true
            this.koreFilter = true
        } else {
            this.koreCarrierAvailable = false
            this.koreFilter = false
        }
        this.countCarriers = Number(this.simonCarrierAvailable) + Number(this.tmobileCarrierAvailable) + Number(this.vodafoneCarrierAvailable) + Number(this.koreCarrierAvailable)

        this.getTagsList();
        if (this.selectedPlans.length == 0) {
            this.getPlansList();
        }

        this.setFilters();
        this.setInitialFilters()
    },
    updated() {
    },
    created() {
    },
};
</script>
<style src="spinkit/scss/spinkit.scss" lang="scss" />
<style lang="scss">
    table {
        thead {
            tr {
                &[aria-selected] {
                    background-color: transparent;
                }
                th {
                    cursor: pointer;
                    &::after {
                        display: none;
                    }
                }
            }


            tr {
                th {
                    border-color: #1A1C1D;
                }

                &[select-all="true"] {
                    .fts-checkbox-table {
                        border-color: #000000;
                        &::before {
                            background-color: #000000;
                        }
                    }
                }
            }
            &[aria-selected="true"] {
                background-color: #0088FF;
                border: 0;
                td {
                    background-color: #0088FF !important;
                }
                .tag-iterator {
                    border-color: #000;
                }
            }
        }
        td {
            padding: 5px 10px;
            &[aria-colindex="5"] {
                font-size: 12px;
                p {
                    font-size: 14px;
                }
            }
        }
        .carrier-cell {
            white-space: nowrap;
            .plan-category-type {
                margin: 0 0 0 10px;
                padding: 3px 7px;
                -webkit-border-radius: 2px;
                -moz-border-radius: 2px;
                border-radius: 2px;
                font-weight: 700;
                &.FLEX,
                &.TETHERING {
                    background-color: #abe390;
                }
                &.NB_IOT {
                    background-color: #8ac8ff;
                }
                &.CAT_M1 {
                    background-color: #ffc400;
                }
            }
        }
        p {
            margin: 0;
        }
    }

    .content-usage {
        min-height: 190px;
        padding: 20px;
        background-color: #f0f3f5;
        border-radius: 5px;
        border: 1px solid #c8ced3;
        > em {
            display: block;
            text-align: center;
            line-height: 190px;
            font-style: normal;
            font-weight: 700;
            font-size: 15px;
        }
    }

    .filter-reports {
        .col-sm-8 {
            display: flex;
            justify-content: flex-start;
            .form-check {
                height: 33px;
                padding: 0 10px;
                margin-right: 10px;
                line-height: 33px;
                background-color: #f0f3f5;
                border: 1px solid #c8ced3;
                box-sizing: border-box;
                border-radius: 5px;
                input {
                    position: relative;
                    margin: 0 10px 0 0;
                    display: inline-block;
                }
            }
        }
    }

    .card-charges {
        .box {
            min-height: 100px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: #f0f3f5;
            border: 1px solid #c8ced3;
            border-radius: 5px;
            text-align: center;
            .data {
                font-size: 24px;
                em {
                    font-style: normal;
                }
            }
            .text {
                font-size: 14px;
            }
            &.total {
                border-top: 5px solid #0072cb;
            }
            &.total2 {
                border-top: 5px solid #23a579;
            }
            &.monthly {
                border-top: 5px solid #aa6fde;
            }
            &.actvation {
                border-top: 5px solid #b88c26;
            }
        }
    }

    .buttons-actions {
        background-color: transparent !important;
        border: 0;
        -webkit-box-shadow: none !important;
        -moz-box-shadow: none !important;
        box-shadow: none !important;
        i {
            margin: 0px;
        }
    }

    .wrap-sims {
        position: relative;

        .card-body {
            label[for="size-page"] {
                margin: 7px 10px 0 0;
            }
            .col-md-4 {
                display: flex;
                align-items: flex-end;
                .form-group {
                    width: 100%;
                }
            }
        }

        .card {
            //min-height: 84vh;
            height: 100%;
        }
        @media (min-width: 1200px) and (max-width: 1600px) {
            .table-managment {
                font-size: 0.75em;
            }
        }
    }

    .modal-place {
        position: static;
    }

    .card-body {
        label[for="size-page"],
        label[for="export-setting"] {
            margin: 7px 10px 0 0;
        }
    }
    .wrapper-sims-list {
        position: relative;
        margin-bottom: 40px;

        .card-body {
            padding-left: 0;
            padding-right: 0;
        }

        .row {
            .wrap-sims {
                .fts-table-wrapper {
                    &.overflow-visible {
                        overflow: visible;
                    }
                    .card-body {
                        .filter-row {
                            .left-side {
                                position: relative;
                                display: flex;
                                .filter-btn {
                                    margin-left: 10px;
                                    white-space: nowrap;
                                }
                            }
                        }
                    }
                }
            }
        }

        .filters-box {
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: rgba(0, 0, 0, .6);
            z-index: 3090;

            .mobile-close {
                display: none;
                position: absolute;
                top: 60px !important;
                right: 10px;
                z-index: 3090;
            }
            @media screen and (max-width: 991px) {
                .mobile-close {
                    display: initial;
                }
            }

            .inner-filters {
                position: relative;
                display: flex;
                flex-direction: column;
                max-width: 1140px;
                width: 100%;
                max-height: 870px;
                height: 90vh;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                background-color: #fff;
                .close-filters-icon {
                    position: absolute;
                    top: 20px;
                    right: 20px;
                    cursor: pointer;
                    &.light-mode {
                        display: initial;
                    }
                    &.dark-mode {
                        display: none;
                    }
                }
                .filters-content {
                    display: flex;
                    flex-direction: column;
                    flex-grow: 1;
                    max-height: 870px;
                    height: 90%;
                    .filter-columns {
                        flex-grow: 1;
                        display: flex;
                        flex-wrap: nowrap;
                        max-height: 735px;
                        overflow-y: scroll;
                        .column {
                            overflow-y: auto;
                            overflow-x: hidden;
                            border-right: 1px solid #DADADA;
                            &:last-child {
                                border-right: 0;
                            }
                            &.statuses {
                                .statuses-box {
                                    width: 480px;
                                    border-bottom: 1px solid #c9cfd4;
                                    &:last-child {
                                        border-bottom: 0;
                                    }
                                    .company-statuses-box {
                                        width: 100%;
                                        padding: 25px 20px;
                                        .logo-switch-row {
                                            margin: 0 0 30px;
                                            img {
                                                height: 28px;
                                                width: auto;
                                                &.light-mode {
                                                    display: initial;
                                                }
                                                &.dark-mode {
                                                    display: none;
                                                }
                                            }
                                        }
                                        .statuses-list {
                                            columns: 200px 2;
                                            .FTScheckbox {
                                                height: initial;
                                                margin-bottom: 2px;
                                            }
                                        }
                                    }
                                    &.double {
                                        display: flex;
                                        flex-wrap: nowrap;
                                        .company-statuses-box {
                                            width: 50%;
                                            border-right: 1px solid #c9cfd4;
                                            &:last-child {
                                                border-right: 0;
                                            }
                                            .statuses-list {
                                                column-count: 1;
                                            }
                                        }
                                    }
                                }
                            }
                            &.tags {
                                width: 330px;
                                padding: 25px 20px;
                                background-color: #F9F9F9;
                                .tags-title {
                                    margin: 0 0 10px;
                                    font-size: 15px;
                                    font-weight: 700;
                                }

                                .selected-tags-count {
                                    margin: 0 0 12px;
                                }

                                .tags-list-header {
                                    margin: 0 0 12px;
                                    font-size: 15px;
                                    font-weight: 700;
                                }

                                .FTSsearch {
                                    display: flex;
                                    align-items: center;
                                    width: 300px;
                                    height: 35px;
                                    padding: 6px 18px;
                                    background-color: #e4e5e6;
                                    border: 1px solid #c9cfd4;
                                    -webkit-border-radius: 5px;
                                    -moz-border-radius: 5px;
                                    border-radius: 5px;
                                    input {
                                        flex-grow: 1;
                                        margin-left: 14px;
                                        background-color: #e4e5e6;
                                        border: none;
                                        &:focus {
                                            outline: none;
                                        }
                                    }
                                }

                                .tag-list-sort {
                                    margin-bottom: 14px;
                                    span {
                                        margin-right: 8px;
                                    }
                                    a {
                                        margin-right: 50px;

                                        &.sort-asc {
                                            &::after {
                                                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='10.002' viewBox='0 0 6 10.002'%3E%3Cg id='Group_21113' data-name='Group 21113' transform='translate(-843 -194)'%3E%3Cpath id='Path_13278' data-name='Path 13278' d='M5.6,9.766l-3-4h6Z' transform='translate(851.6 203.767) rotate(180)' fill='%2308f'/%3E%3Cpath id='Path_13396' data-name='Path 13396' d='M3,4,0,0H6Z' transform='translate(843 200.003)' fill='%23515b65'/%3E%3C/g%3E%3C/svg%3E%0A");
                                            }
                                        }

                                        &.sort-desc {
                                            &::after {
                                                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='10.002' viewBox='0 0 6 10.002'%3E%3Cg id='Group_21114' data-name='Group 21114' transform='translate(-860 -194.001)'%3E%3Cpath id='Path_13278' data-name='Path 13278' d='M5.6,9.766l-3-4h6Z' transform='translate(857.4 194.237)' fill='%2308f'/%3E%3Cpath id='Path_13396' data-name='Path 13396' d='M3,4,0,0H6Z' transform='translate(866 198.001) rotate(180)' fill='%23515b65'/%3E%3C/g%3E%3C/svg%3E%0A");
                                            }
                                        }

                                        i {
                                            margin-left: 8px;
                                            color: #0088FF;
                                        }
                                        cursor: pointer;
                                        &.sorting {
                                            font-weight: 700;
                                        }
                                    }
                                }

                                .selected-tags-list {
                                    display: flex;
                                    flex-wrap: wrap;
                                    margin-bottom: 12px;
                                    gap: 4px;
                                    .selected-tag {
                                        display: flex;
                                        align-items: center;
                                        justify-content: space-between;
                                        color: #fff;
                                        border: 1px solid #0088ff;
                                        -webkit-border-radius: 4px;
                                        -moz-border-radius: 4px;
                                        border-radius: 4px;
                                        font-size: 14px;
                                        padding: 4px;
                                        background-color: #0088ff;
                                        cursor: pointer;
                                        &.hidden {
                                            display: none;
                                        }
                                        .close-cross {
                                            width: 14px;
                                            height: 14px;
                                            margin-left: 6px;
                                        }
                                    }
                                }
                                .FTSsearch {
                                    margin-bottom: 14px;
                                }
                                .tags-list {
                                    display: flex;
                                    flex-wrap: wrap;
                                    gap: 4px;
                                    .tag {
                                        color: #2F353A;
                                        border: 1px solid #C9CFD4;
                                        -webkit-border-radius: 4px;
                                        -moz-border-radius: 4px;
                                        border-radius: 4px;
                                        font-size: 14px;
                                        padding: 4px;
                                        background-color: #fff;
                                        cursor: pointer;
                                        &.selected,
                                        &.hidden {
                                            display: none;
                                        }
                                        &:hover {
                                            border-color: #0088ff;
                                        }
                                    }
                                }
                            }
                            &.plans {
                                width: 330px;
                                padding: 25px 20px;
                                background-color: #F9F9F9;

                                .plans-title {
                                    margin: 0 0 10px;
                                    font-size: 15px;
                                    font-weight: 700;
                                }

                                .plans-alpha-box {
                                    &.hidden {
                                        display: none;
                                    }
                                    .FTScheckbox {
                                        .FTScheckbox-content {
                                            line-height: 1.2;
                                        }
                                    }
                                }

                                .selected-plans-box {
                                    display: flex;
                                    margin-bottom: 10px;
                                    flex-wrap: wrap;
                                    .selected-plan {
                                        display: flex;
                                        align-items: center;
                                        margin-bottom: 10px;
                                        margin-right: 10px;
                                        color: #ffffff;
                                        padding: 6px;
                                        -webkit-border-radius: 5px;
                                        -moz-border-radius: 5px;
                                        border-radius: 5px;

                                        &.simon-plan {
                                            background-color: #00B1FF;
                                        }
                                        &.tmobile-plan {
                                            background-color: #E20074;
                                        }
                                        &.vodafone-plan {
                                            background-color: #EE3023;
                                        }
                                        &.kore-plan {
                                            background-color: #F58320;
                                        }
                                        .company-plan-logo {
                                            margin-right: 16px;
                                        }

                                        .close-cross {
                                            margin-left: 8px;
                                            cursor: pointer;
                                        }
                                    }
                                }

                                .plans-filters-box {
                                    margin-top: 12px;
                                    margin-bottom: 20px;
                                    display: flex;
                                    flex-wrap: wrap;
                                    a {
                                        margin-right: 20px;
                                        color: #2F353A;
                                        cursor: pointer;
                                        white-space: nowrap;
                                        &:hover{
                                            color: #0088FF;
                                        }
                                        &.active-filter {
                                            color: #0088FF;
                                        }
                                    }
                                }

                                .plans-list {
                                    .plans-alpha-box {
                                        h6 {
                                            margin-top: 12px;
                                            margin-bottom: 12px;
                                        }
                                    }
                                }

                                .FTSsearch {
                                    display: flex;
                                    align-items: center;
                                    width: 300px;
                                    height: 35px;
                                    padding: 6px 18px;
                                    background-color: #e4e5e6;
                                    border: 1px solid #c9cfd4;
                                    -webkit-border-radius: 5px;
                                    -moz-border-radius: 5px;
                                    border-radius: 5px;
                                    input {
                                        flex-grow: 1;
                                        margin-left: 14px;
                                        background-color: #e4e5e6;
                                        border: none;
                                        &:focus {
                                            outline: none;
                                        }
                                    }
                                }

                                .FTScheckbox {
                                    &.hidden {
                                        display: none;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .filters-search {
                padding: 20px;
                border-bottom: 1px solid #c9cfd4;
                .FTSsearch {
                    padding-right: 6px;
                    .clear-filters-icon {
                        cursor: pointer;
                        &.light-mode {
                            display: initial;
                        }
                        &.dark-mode {
                            display: none;
                        }
                    }
                }
            }
            .comapnies-statuses-row {
                display: flex;
                justify-content: space-between;
                border-bottom: 1px solid #c9cfd4;
                .company-statuses-box {
                    flex-grow: 1;
                    display: flex;
                    flex-direction: column;
                    max-height: 350px;
                    padding: 20px;
                    border-right: 1px solid #c9cfd4;
                    &.part-1 {
                        min-width: 100%;
                    }
                    &.part-2 {
                        min-width: 50%;
                    }
                    &.part-3 {
                        min-width: 33.333%;
                    }
                    &:last-child {
                        border-right: none;
                    }
                    .logo-switch-row {
                        display: flex;
                        justify-content: space-between;
                        img {
                            height: 26px;
                            width: auto;
                            &.light-mode {
                                display: block;
                            }
                            &.dark-mode {
                                display: none;
                            }
                        }
                    }
                    h4 {
                        margin: 22px 0 18px;
                        font-size: 15px;
                        font-weight: 700;
                    }
                    .statuses-list {
                        display: flex;
                        flex-direction: column;
                        flex-wrap: wrap;
                        max-height: 200px;
                        .FTScheckbox {
                            width: 50%;
                            &.hidden {
                                display: none;
                            }
                        }
                    }
                    .select-all-row {
                        display: flex;
                        justify-content: flex-end;
                        align-items: flex-end;
                        a {
                            color: #00b1ff;
                            text-transform: uppercase;
                            font-weight: 700;
                            cursor: pointer;
                        }
                    }
                }
            }
            .tags-plans-row {
                height: 400px;
                display: flex;
                background-color: #f9f9f9;
                .tags-box {
                    flex-grow: 1;
                    max-width: 50%;
                    padding: 20px;
                    border-right: 1px solid #c9cfd4;
                    overflow: auto;
                }
                .plans-box {
                    max-width: 50%;
                    flex-grow: 1;
                    padding: 20px;
                    overflow: auto;
                }
            }
            .filters-control-bar {
                display: flex;
                justify-content: space-between;
                padding: 12px 20px;
                background-color: #fff;
                border-top: 1px solid #DADADA;
                .left-side {
                    align-items: center;
                    .btn-light {
                        margin-right: 10px;
                        white-space: nowrap;
                    }
                }
                .right-side {
                    display: flex;
                    justify-content: flex-end;
                    flex-grow: 1;
                    .btn-primary {
                        margin-left: 10px;
                    }
                }
            }
        }
    }
    .footer-actions {
        padding: 10px 20px;
        position: fixed;
        left: 200px;
        right: 0;
        bottom: 0;
        background-color: #3A4149;
        z-index: 2080;

        .inner-footer {
            display: flex;
            justify-content: space-between;

            .left,
            .right {
                display: flex;
                justify-content: stretch;
                button {
                    line-height: 21px;
                }
            }

            select {
                display: inline-block;
                width: auto;
                margin: 0 20px;

                background-color: #edeeef;
            }
        }
    }

    .input-tag {
        display: flex;
        max-width: 100%;

        .form-control {
            border-bottom-right-radius: 0;
            border-top-right-radius: 0;
        }

        .btn {
            min-width: 80px;
            margin-bottom: 10px;
            border-bottom-left-radius: 0;
            border-top-left-radius: 0;
            right: 0;
        }
    }

    .drag-area {
        display: flex;
        justify-content: space-between;

        .drag-inner {
            padding: 0 20px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border: 2px dashed #fff;
            border-right-width: 0;
            border-radius: 5px 0 0 5px;
            box-sizing: border-box;

            &.dragged-fiel {
                background-color: rgba(255, 255, 255, .4);
            }

            img {
                margin-right: 10px;
            }
            span {
                white-space: nowrap;
                color: #fff;
            }
        }

        label {
            margin: 0;
            width: 100%;
            border-radius: 5px;
            display: inline-block;
            box-sizing: border-box;
            border: 2px solid #0088FF;

            input {
                display: none;
            }
        }

        .btn {
            background-color: #0088FF;
            -webkit-appearance: none;
        }
    }


    .wrapper-modal {
        position: fixed;
        width: 100vw;
        height: 100vh;
        /*min-height: 100vh;*/
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: rgba(44, 44, 44, 0.9);
        z-index: 3030;

        &.wrapper-disable {
            display: none;
        }

        .file-format-popup {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 500px;
            background-color: #fff;
            padding: 20px;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;

            h3 {
                font-size: 15px;
                margin-top: 8px;
                margin-bottom: 20px;
            }

            .btn {
                width: 100px;
            }

            .btn-primary {
                margin: 0 10px 20px;
            }

            .btn-light {
                margin: 10px 0 0;
            }

            .csv {
                background-color: #00559F;
                border-color: #00559F;
            }
            .xls {
                background-color: #207245;
                border-color: #207245;
            }

            .close-icon {
                position: absolute;
                top: 20px;
                right: 20px;
                cursor: pointer;
            }
        }
    }

    select.form-control {
        display: inline-block;
        &.export-dropdown {
            max-width: 150px;
        }
    }

    .management-list-control {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;

        .select-control {
            display: flex;
            align-items: center;
            height: 35px;
            input {
                margin-right: 12px;
            }
        }

        .export-control {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            align-content: center;

            label[for="export-setting"] {
                margin-top: 0;
            }

            .btn-primary {
                padding-left: 10px;
                padding-right: 10px;
                text-align: center;
                margin-left: 15px;
            }
        }
    }


 select.form-control {
     display: inline-block;
     background-color: #fff;
     &.export-dropdown {
         max-width: 150px;
     }
 }

 .management-list-control {
     display: flex;
     align-items: flex-end;
     justify-content: space-between;

     .select-control {
         display: flex;
         align-items: center;
         height: 35px;
         input {
             margin-right: 12px;
         }
     }

     .export-control {
         display: flex;
         justify-content: flex-end;

         .btn-primary {
             padding-left: 10px;
             padding-right: 10px;
             text-align: center;
             margin-left: 15px;
         }
     }
 }

    .dark-theme {
        .wrapper-sims-list {
            .filters-box {
                .inner-filters {
                    .filters-content {
                        .filter-columns {
                            .column {
                                border-right-color: #1a1c1d;
                                background-color: transparent;
                                .statuses-box {
                                    border-color: #1a1c1d;
                                    .company-statuses-box {
                                        border-color: #1a1c1d !important;
                                        .light-mode {
                                            display: none !important;
                                        }
                                        .dark-mode {
                                            display: block !important;
                                        }
                                    }
                                }

                                .tags-list {
                                    .tag {
                                        background-color: #2F353A;
                                        border-color: #1A1C1D;
                                        color: #fff;
                                    }
                                }
                            }
                        }
                    }
                    .filters-control-bar {
                        border-color: #1a1c1d;
                    }

                }
            }
        }
        .table.table-managment,
        .table {
            color: #EDEEEF;

            thead {
                tr {
                    border-color: #1A1C1D;
                    th {
                        border-color: #1A1C1D;
                    }

                    &[select-all="false"] {
                        .fts-checkbox-table {
                            border-color: #EDEEEF;
                        }
                    }

                    &[select-all="true"] {
                        .fts-checkbox-table {
                            border-color: #000000;
                            &::before {
                                background-color: #000000;
                            }
                        }
                        th {
                            border-color: #1A1C1D;
                            color: #23282c;
                            .btn-secondary {
                                .fa-pencil {
                                    color: #23282c;
                                }
                            }
                        }
                    }
                }
            }

            tbody {
                tr {
                    &:nth-of-type(odd) td {
                        background-color: #2F353A;
                    }
                    &:nth-of-type(even) td {
                        background-color: #3A4149;
                    }

                    td {
                        border-color: #1A1C1D;
                        .btn-secondary {
                            .fa-pencil {
                                color: #EDEEEF;
                            }
                        }
                    }

                    &[aria-selected="false"] {
                        .fts-checkbox-table {
                            border-color: #EDEEEF;
                        }
                    }

                    &[aria-selected="true"] {
                        .fts-checkbox-table {
                            border-color: #000000;
                            &::before {
                                background-color: #000000;
                            }
                        }
                        td {
                            border-color: #1A1C1D;
                            color: #fff;
                            background-color: #0088FF;
                            .btn-secondary {
                                .fa-pencil {
                                    color: #23282c;
                                }
                            }
                        }
                    }
                    &:hover td{
                        background-color: #0088FF;
                    }
                }
            }
        }
        .container-fluid {
            .card {
                .card-body {
                    .form-control {
                        background-color: #515b65;
                        border-color: #1a1c1d;
                        color: #EDEEEF;
                        &::placeholder {
                            color: #EDEEEF;
                        }
                    }
                }
            }
        }


        .custom-select {
            background: url('data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 4 5\'%3e%3cpath fill=\'%23EDEEEF\' d=\'M2 0L0 2h4zm0 5L0 3h4z\'/%3e%3c/svg%3e') no-repeat right 0.75rem center/8px 10px #2f353a !important;
            color: #EDEEEF;
            border-color: #2f353a;
        }

        .wrapper-modal {
            .file-format-popup {
                background-color: #3a4149;
                color: #EDEEEF;
            }
        }

        //.wrapper-sims-list .row .wrap-sims .fts-table-wrapper .card-body .filter-row .left-side .filters-box .comapnies-statuses-row .company-statuses-box
        .wrapper-sims-list {
            .filters-box {
                background-color: rgba(0, 0, 0, 0.6);
                -webkit-box-shadow: 0px 0px 20px 3px rgba(40,40,40,1);
                -moz-box-shadow: 0px 0px 20px 3px rgba(40,40,40,1);
                box-shadow: 0px 0px 20px 3px rgba(40,40,40,1);


                .inner-filters {
                    display: flex;
                    flex-direction: column;
                    .filters-search {
                        border-color: #1a1c1d;
                    }
                    .close-filters-icon {
                        &.light-mode {
                            display: none;
                        }
                        &.dark-mode {
                            display: initial;
                        }
                    }
                }
                .FTSsearch {
                    .clear-filters-icon {
                        &.light-mode {
                            display: none;
                        }
                        &.dark-mode {
                            display: initial;
                        }
                    }
                }
                .comapnies-statuses-row {
                    border-color: #1a1c1d;
                    background-color: #3a4149;
                    .company-statuses-box {
                        border-color: #1a1c1d;
                        .logo-switch-row {
                            img {
                                &.light-mode {
                                    display: none;
                                }
                                &.dark-mode {
                                    display: block;
                                }
                            }
                        }
                    }
                }
                .tags-plans-row {
                    background-color: #343a41;
                    .tags-box,
                    .plans-box {
                        .FTSsearch {
                            background-color: #515b65;
                            border: 1px solid #1a1c1d;
                            input {
                                background-color: #515b65;
                                color: #edeeef;
                                &::placeholder {
                                    color: #edeeef;
                                }
                            }
                        }
                    }
                    .tags-box {
                        border-color: #1a1c1d !important;
                        .tags-search-container,
                        .tag-list-sort,
                        .tags-list-header {
                            background-color: #343a41;
                        }
                        .tags-list {
                            .tag {
                                background-color: #3a4149;
                                border-color: #1a1c1d;
                                color: #fff;
                            }
                        }
                    }
                    .plans-box {
                        .plans-filters-box {
                            display: flex;
                            flex-wrap: wrap;
                            a {
                                white-space: nowrap;
                                color: #fff;
                            }
                        }
                    }
                }
                .filters-control-bar {
                    background-color: #2f353a;
                }
            }
        }
    }

.options-mobile {
    position: relative;
    display: none;
}

</style>